
import { Component, ViewChild, Inject, OnInit, HostListener,ElementRef } from '@angular/core';
import { Router } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { BookingService } from "../../booking/service/booking.service";
import { GuestAppointmentService } from "../Service/GuestAppointment.Service";
import { LoginService } from "../../login/service/login.service";
import { BookingDataModel, UserData, GeneralBookingModel, Bookingkeyvaluepair, LoginModel, FileSearch } from "../../model/index"
import { ManadatoryFieldsDataModel, NationalityModel, TitleModel, AreaDataModel, BloodGroups, RelationFields, ReligionDetails, RegistrationDataModel, AlternateType, Gender, ProviderCode, requestParam, responseParam} from "../../model/index";
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { IonRangeSliderComponent } from "ng2-ion-range-slider";
import { ModalComponent } from "../../shared/modeldialog/index";
import { SecurityService } from '../../Security/security.service';
import { FileToUpload } from "../../Model/Documents/FileToUpload";
declare var require: any;


declare let jspdf: any;
declare let html2canvas: any;


declare var bookingGrid: any;
declare let Checkout: any;
declare let MaxWallet: any;
declare let CryptoJS: any;


@Component({
    selector: 'MentisSoft-Booking',
    template: require('../Template/GuestAppointment.template.html'),
    providers: [LoginService],
    styles: [require('../Template/GuestAppointment.css')]
})

export class GuestAppointmentComponent implements OnInit {

    @ViewChild("viewModelPopup") viewModelPopup: ModalComponent;
    @ViewChild('civilId') civilId: ElementRef;
	@ViewChild('PatientcivilId') PatientcivilId: ElementRef;
    @ViewChild('insuraceId') insuraceId: ElementRef;
	@ViewChild('PatientinsuraceId') PatientinsuraceId: ElementRef;
    @ViewChild("BookingConfirmed") BookingConfirmed: ModalComponent;
    @ViewChild("loadingindicator") loadingindicator: ModalComponent;
    @ViewChild("loadingProcess") loadingProcess: ModalComponent;
    @ViewChild("Alertpayment") Alertpayment: ModalComponent;
    @ViewChild('advancedSliderElement') advancedSliderElement: IonRangeSliderComponent;
    @ViewChild("slotAllotment") slotAllotment: ModalComponent;
    @ViewChild("BookingDoctorOnline") BookingDoctorOnline: ModalComponent;
    @ViewChild("IsPatientValid") IsPatientValid: ModalComponent;
    @ViewChild("BookingConfirmedPayment") BookingConfirmedPayment: ModalComponent;
    @ViewChild("PopupPayment") PopupPayment: ModalComponent;
    @ViewChild("AlertBookPopup") AlertBookPopup: ModalComponent;
    @ViewChild("openTermConditions") openTermConditions: ModalComponent;
    @ViewChild("PrintPreviewpopup") PrintPreviewpopup: ModalComponent;
    today = new Date();
    ValidDobValidityDate: boolean = true;
    IsReqCivil: boolean = false;
    IsReqOption: boolean = false;
    IsReqOptionMan: boolean = true;
    ValidDate: boolean = true;
    TermsChecked: boolean = false;
    EnteredDateofBirth: string;
    fileSearch: FileSearch = new FileSearch();
    fileSearchRes: FileSearch[] = [];
    appointmentBooking: boolean = false;
    IsPrivateChecked: boolean = false;
    IsPopupPayment: boolean = false;
   
    redirectString: string;
    checkcontrolbook: boolean = false;
    IsPatientPediatric: boolean = false;
    IsPatientValidFailed: boolean = false;
    fileList: string[] = [];
   
    MAX_SIZE: number = 5048576;
    theFile: any = null;
    messages: string[] = [];
   
    errormessage: string = "";
    IsPatientOBGYN: boolean = false;
    appointmentPatientId: string = "";
    appointmentCivilId: string = "";
    selectedPatientId: string = "";
    enableProceed: boolean = false;
    isSlotValueChosen: boolean = false;
    slotErrorMessage: string = "NO";
   
    SelecterrMsg: string = "";
    SelecterrMsg1: string = "";
    CvilIdNoRed: boolean = false;
    IsselectPatientSearch: boolean = false;
    IsselectPatientSearch1: boolean = false;
    IsPatientcountone: boolean = true;
    IsMobileText: boolean = false;
    IsEnglish: boolean = false;
    HospitalName: string = "";

	 IsPatientReqCivil: boolean = false;
     IsPatientCivilRed: boolean = false;
     IsPatientReqInsurance: boolean = false;
	 IsPatientInsuranceReq: boolean = false;
	 IsPatientReqSelf: boolean = false;
	 IsValidInsuredDoc: boolean = true;
    year = new Date();
    appDate: Object = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
    appDate1: Object = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
    activebutton: number = this.year.getDay();
    activebutton1: number = this.year.getDay();
    myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
        firstDayOfWeek: 'su',
        satHighlight: false,
        sunHighlight: false,
       
    };

    month = ("0" + (this.year.getMonth() + 1)).slice(-2);
    date: string = ("0" + this.year.getDate()).slice(-2) + "/" + this.month + "/" + this.year.getFullYear();
    depts = [];
    Locs = [];
    generalBooking: GeneralBookingModel = new GeneralBookingModel();
    dataSource: BookingDataModel[] = [];
    dataSourceOriginal: BookingDataModel[] = [];
    columns: any[] = [];
    bookingFilter: BookingDataModel;
    isValid = true;
    isValidPayment: boolean = false;
    PaymentErroMsg: string = "";
    mobilePlaceHolder: string = "";
    guestBooking: boolean = false;
    
    IsFirstNameRed: boolean = false;
    IsLastNameRed: boolean = false;
    IsMiddleNameRed: boolean = false;
    IsEmailRed: boolean = false;
    IsEmailValidation: boolean = false;
    IsSelectEmailRed: boolean = false;
    IsSelectEmailValidation: boolean = false;
    IsMobileNoRed: boolean = false;
    MobileNoValid: boolean = false;
    MobileNoValid1: boolean = false;
    IsSearchMobileNumberRed: boolean = false;
    SearchMobileNumber: string = "";
   
    IsBookingConfirmed: boolean = false;
    IsBookingConfirmedPayment: boolean = false;
    IsBookingDoctorOnline: boolean = false;
    clickedDate: string;
    FirstName: string = "";
    MiddleName: string = "";
    LastName: string = "";
    advancedSlider = { name: "Advanced Slider", onUpdate: undefined, onFinish: undefined };
    timeSlotsArray: Bookingkeyvaluepair[] = [];
  
    slotMessage: string = "If a slot is chosen, please make payment within 5 minutes else the slot will remain unbooked."
    selectedSlotDrCode: string;
    CurrencyValue: string;
    loginInfo: LoginModel = new LoginModel();
    chosenSlotValue: number;
    message: string = "";
    slotBookingFailed: boolean = false;
    selectedSlotClass: string;
   
    scheduledStartTime: string;
    scheduledEndTime: string;
    enableJnhPopup: string;
    enableHadiPopup: string;
    DoctorsSlotTiming: string;
    BookingType: string = "";
    PaymentType: string = "";
    GuestNewPatientReq: string = "";
    CPRNOlength: string = "";
    IsDefaultBackVisible: string = "";
    doctorName: string = "";
    NativeDeptName: string = "";
    NativeDoctorName: string = "";
    disableback: boolean = false;
    IsSearchValue: string = "";
    loading = false;
    Querynumber: string;
    QueryResult: string;
   
    IsValidConfirm: boolean = false;
    PayedDeptName: string = "";
    PayedDoctorName: string = "";
    PayedPayAmount: string = "";
    PayedSlot: string = "";
   
    Cancelurl: string = "";
    payLaterStatus: string = "";
    IsConfirmPay: boolean = false;
    Printurl: string = "";
    transactionNo: string = "";
    IsTransaction: boolean = true;
    IsHelpLineNo: boolean = true;
    IsTokenNo: boolean = true;
    AppointmentNo: string = "";
    IsGuestEmailReq: boolean = false;
    ReceiptNo: string = "";
    PatientId: string = "";
    InstructionEng: string = "";
    InstructionArabic: string = "";
    trackid: string = "";
    AppointmentDate: string = "";
  
    IsAlertBookPopup: boolean = false;
    HelpLineNo: string = "";
    JnhFirstSlot: string = "";
    TokenNo: string = "";
    PrintPatientName: string = "";
    CPRNONumber: string = "";
    ClinicName: string = "";
    CompanyPostBox: string = "";
    CompanyAddress: string = "";
    CompanyPhoneNumber: string = "";
    CompanyFax: string = "";
    CompanyEmail: string = "";
    CompanyLinkEmail: string = "";
    ISSelfPayOption: string = "TRUE";
    IsPortal: boolean = true;
    IsDownload: boolean = true;
    AppNumber: string = "";
    PortalDesc: string = "";
    NationalityDataModel: NationalityModel[] = [];
    manadatoryFieldsDataModel: ManadatoryFieldsDataModel[] = [];
    TitleModel: TitleModel[] = [];
    AlternateTypeList: AlternateType[] = [];
    genderList: Gender[] = [];
    AreaDataModel: AreaDataModel[] = [];
    AlternateNolength: string = "";
    myDobDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
    };
    IsReqInsurance: boolean = false;
    IsReqArea: boolean = false
    mandatoryParams: Object = {};
    IsRequiredTitle: boolean = false;
    IsReqAlternateType: boolean = false;
    IsReqFirstName: boolean = false;
    IsReqMiddleName: boolean = false;
    IsReqLastName: boolean = false;
    IsReqEmployer: boolean = false;
    IsReqOccouption: boolean = false;
    IsReqpassportNo: boolean = false;
    IsReqPassportValidity: boolean = false;
    IsReqAltNO: boolean = false;
    IsReqAltnoValidity: boolean = false;
    IsReqNationality: boolean = false;
    IsReqGender: boolean = false;
    IsReqMobileNo: boolean = false;
    IsReqEmail: boolean = false;
    IsReqDob: boolean = false;
    IsReqFlat: boolean = false;
    IsReqBlock: boolean = false;
    IsReqTown: boolean = false;
    IsNationalityRed: boolean = false;
    IsTitleRed: boolean = false;
    AlternateTypeRed: boolean = false;
    IsDobRed: boolean = false;
    IsGenderRed: boolean = false;
    IsFlatRed: boolean = false;
    IsBlockRed: boolean = false;
    IsTownRed: boolean = false;
    IsAreaRed: boolean = false;
    IsCivilRed: boolean = false;
    AlternateNoRed: boolean = false;
    AlternateNoForthirty: boolean = false;
    IsAlternateNoNumeric = true;
    IDvalue: string = "";
    OtherValue: string = "";
    selectedAltType: string = "";
    InsuredOrSelf: any;
	PatientInsuredOrSelf: any;
	IsPatientInsuredOrSelf: boolean = true;
    hidden: boolean = true;
    AlternateType: any
    SlotVisible: boolean = true;

    IsDocumentAttached: boolean = false;
    IsValidationCivil: boolean = false;
    IsValidationPassport: boolean = false;
    IsValidationeVisa: boolean = false;
    IsValidationMOH: boolean = false;
    IsValidationDocument: boolean = false;
    ISReqDocOption: boolean = false;
    ISDocDepartOption: string = ""; 
    IsUploadDocVisble: boolean = false;
    IsUploadFailmsg: boolean = false;
    UploadFailmsg: string = "";
    ValidateCivil: boolean = false;
    IsuploadValidationErrorMsg: boolean = false;
    UploadValidationErrorMsg: string = "";
    IsCivilFrontImage: boolean = false;
    IsCivilBackImage: boolean = false;
    IsPassportFrontImage: boolean = false;
    IsPassportBackImage: boolean = false;
    IsVisaImage: boolean = false;
    IsMOHImage: boolean = false;
    IsInstructions: boolean = false;
    IsArabic: boolean = false;
    IsProceedPayNow: string = "";
    IsProceedPaybutton: boolean = true;
    BackMenu: string = "BAck TO LOGIN";
    CivilORCPRName: string = "Civil Id/CPR No";
    CivilIDName: string = "Civil Id";
    IsLocationChange: boolean = false;
    IsLocationVisible: boolean = false;
    KioskORPortal: string = localStorage.getItem("KioskORPortal");
    requestparamater: requestParam = new requestParam();
    AppointmentComplted: boolean = false;
	tapQuerynumber:string;

    constructor(@Inject(SecurityService) private _SecurityService: SecurityService, private _LoginService: LoginService, private router: Router, private _bookingService: BookingService, private _titleService: Title, private _registrationService: GuestAppointmentService) {
        bookingGrid = this;
        this.bookingFilter = new BookingDataModel();
        this.IsAlternateNoNumeric = true;
        this.LoadData();
        this.bookingFilter.FromTime = "00:00";
        this.bookingFilter.ToTime = "23:00";
        this.generalBooking.departmentId = "0";
        this.Cancelurl = router.parseUrl(router.url).fragment;
        this.Querynumber = router.parseUrl(router.url).queryParams["Id"];
        this.generalBooking.AppReqPatientId = this.Querynumber;
		this.tapQuerynumber = router.parseUrl(router.url).queryParams["tap_id"];
        this.generalBooking.Tap_id = this.tapQuerynumber;
        this.AppNumber = router.parseUrl(router.url).queryParams["AppNumber"];
        this.generalBooking.AppointmentRquestNo = this.AppNumber;
        this.QueryResult = router.parseUrl(router.url).queryParams["result"];
        if (this.Querynumber == "" || this.Querynumber == undefined) {
            this.Querynumber = this.router.parseUrl(this.router.url).queryParams["result"];
        }

    }

    ngAfterViewInit(): void {
        
        $('#overlay').hide();
        this.IsAlternateNoNumeric = true;
        this._LoginService.GetCurrencyDetails(this.loginInfo)
            .subscribe(
                s => {
                    this.CurrencyValue = s;
                });
        this.HospitalName = localStorage.getItem("HospitalName");
        if (this.HospitalName == "JNH") {
            this.appDate = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() + 1 } };//{ date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() + 1 } };
            this.activebutton = this.year.getDay() + 1;
            this.date = ("0" + (this.year.getDate() + 1)).slice(-2) + "/" + this.month + "/" + this.year.getFullYear();
            this.myDatePickerOptions = {
                disableUntil: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() },

            };
        }
        if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
            this.CivilORCPRName = "CPR No";
            this.CivilIDName = "CPR No";
        }
        this._titleService.setTitle("Guest Appointments");
        if (this.Querynumber != "" && this.Querynumber != undefined && this.QueryResult == "CAPTURED") {
            this.generalBooking.CaptureData = "CAPTURED";
            //if (this.generalBooking.CaptureData == "CAPTURED")
            //    this.Alertpayment.open();
            this.LoadingAfterPayment(this.Querynumber);
        }
        if (this.Querynumber != "" && this.Querynumber != undefined) {
            if (this.QueryResult != "CAPTURED" && this.QueryResult != "" && this.QueryResult != undefined) {
                this.generalBooking.CaptureData = this.QueryResult;
                //if (this.generalBooking.CaptureData == "CAPTURED")
                //    this.Alertpayment.open();
                this.LoadingAfterPayment(this.QueryResult);
            }
            else {
                if (this.QueryResult == "" || this.QueryResult == undefined) {
                    this.generalBooking.CaptureData = this.QueryResult;
                    //if (this.generalBooking.CaptureData == "CAPTURED")
                    //    this.Alertpayment.open();
                    this.LoadingAfterPayment(this.Querynumber);
                }
            }
        }
        if (this.Querynumber == undefined && this.Cancelurl != "" && this.Cancelurl != "" && this.Cancelurl == "__hc-action-cancel") {
            this.generalBooking.CaptureData = "CANCEL";
            //if (this.generalBooking.CaptureData == "CAPTURED")
            //    this.Alertpayment.open();
            this.LoadingAfterPayment("CANCEL");
        }
        if (this.Querynumber == "" && this.QueryResult == "") {
            this.generalBooking.CaptureData = "DENIED+BY+RISK";
            //if (this.generalBooking.CaptureData == "CAPTURED")
            //    this.Alertpayment.open();
            this.LoadingAfterPayment("DENIED+BY+RISK");
        }       
		if (this.tapQuerynumber != "" && this.tapQuerynumber != undefined) {
            this.generalBooking.CaptureData = "TAPPAY";
            //if (this.generalBooking.CaptureData == "CAPTURED")
            //    this.Alertpayment.open();
            this.LoadingAfterPayment("TAPPAY");
        }    
        this.LoadBookingReports();

    }

    

    ngOnInit() {
        this.InsuredOrSelf = 'selfPay';
		this.PatientInsuredOrSelf = 'selfPay';
        if (localStorage.getItem("HospitalName").toUpperCase() == "BSH" || localStorage.getItem("HospitalName").toUpperCase() == "DEMO") {
            this.IsLocationVisible = true;
            this.LoadLocation();
        }
        this.LoadDepartments();
        //this.Alertpayment.close();
    }

    LoadData() {
        this._SecurityService.authentication = "TESTAUTH";
        this._registrationService.GetTitle("", this._SecurityService.authentication)
            .subscribe(
                p => {
                    this.CPRNOlength = p.CPRNOlength;
                    this.HospitalName = p.HospitalName;
                    this.TitleModel = p.GetTitleList;
                    this.InsuredOrSelf = 'selfPay';
					this.PatientInsuredOrSelf = 'selfPay';
                    this.NationalityDataModel = p.NationalityFields;
                    this.AlternateTypeList = p.AlternateTypeList;
                    this.AlternateType = p.AlternateTypeList[0].Code;

                    this.AlternateNolength = '20';
                    this.genderList = p.GenderList;
                    this.AreaDataModel = p.AreaList;
                    this.manadatoryFieldsDataModel = p.MandatoryFields;
                    for (var i = 0; i < p.MandatoryFields.length; i++) {
                        this.mandatoryParams[p.MandatoryFields[i].FieldName.toUpperCase()] = p.MandatoryFields[i].MandatoryFlag;
                    }
                    this.AssignMandatoryFields();


                    this.loading = false;
                });
    }


    AssignMandatoryFields() {

        if (this.mandatoryParams["TITLE"] == true) { this.IsRequiredTitle = true }
        else { this.IsRequiredTitle = false; }
        if (this.mandatoryParams["NATIONALITY"] == true) { this.IsReqNationality = true }
        else { this.IsReqNationality = false; }
        if (this.mandatoryParams["DATE OF BIRTH"] == true) { this.IsReqDob = true }
        else { this.IsReqDob = false; }
        if (this.mandatoryParams["ALTERNATE NO."] == true) { this.IsReqAltNO = true }
        else { this.IsReqAltNO = false; }

        if (this.mandatoryParams["AREA/ISLAND"] == true) { this.IsReqArea = true }
        else { this.IsReqArea = false; }

        if (this.mandatoryParams["FLAT NUMBER"] == true) { this.IsReqFlat = true }
        else { this.IsReqFlat = false; }

        if (this.mandatoryParams["TOWN"] == true) { this.IsReqTown = true }
        else { this.IsReqTown = false; }


        this.IsReqGender = true;
        this.IsReqTown = true;
        this.IsReqAlternateType = true;
        this.IsReqBlock = true;
        this.IsReqCivil = true;
        this.IsReqOption = true;
        this.IsCivilRed = true;
    }
    ValidateArea() {
        if (this.IsReqArea == true) {
            if (this.generalBooking.AreaCode == "null" || this.generalBooking.AreaCode == "" || this.generalBooking.AreaCode == undefined) {
                this.IsAreaRed = true;
            }
            else {
                this.IsAreaRed = false;
            }
        }
    }

     ValidateCivilDoc() {
        if (this.IsReqCivil == true) {
            if (this.generalBooking.CivilIdDoc == null) {
                this.IsCivilRed = true;
            }
            else {
                this.IsCivilRed = false;
            }
        }
    }
     ValidateInsuranceDoc() {
         if (this.IsReqInsurance === true) {
             if (this.generalBooking.InsuredIdDoc == null) {
                 this.IsReqInsurance = true;
             }
             else {
                 this.IsReqInsurance = false;
             }
         }
     }

    ValidateFlat() {
        if (this.IsReqFlat == true) {
            if (this.generalBooking.flatno == "null" || this.generalBooking.flatno == "" || this.generalBooking.flatno == undefined) {
                this.IsFlatRed = true;
            }
            else {
                this.IsFlatRed = false;
            }
        }
    }
    ValidateBlock() {
        if (this.IsReqBlock == true) {
            if (this.generalBooking.BlockNo == "null" || this.generalBooking.BlockNo == "" || this.generalBooking.BlockNo == undefined) {
                this.IsBlockRed = true;
            }
            else {
                this.IsBlockRed = false;
            }
        }
    }
    ValidateTown() {
        if (this.IsReqTown == true) {
            if (this.generalBooking.Town == "null" || this.generalBooking.Town == "" || this.generalBooking.Town == undefined) {
                this.IsTownRed = true;
            }
            else {
                this.IsTownRed = false;
            }
        }
    }

    ValidateNationality() {
        if (this.IsReqNationality == true) {
            if (this.generalBooking.Nationality == "null" || this.generalBooking.Nationality == "" || this.generalBooking.Nationality == undefined) {
                this.IsNationalityRed = true;
            }
            else {
                this.IsNationalityRed = false;
            }
        }
    }
    ValidateTitle() {
        if (this.IsRequiredTitle == true) {
            if (this.generalBooking.TitleCode == "null" || this.generalBooking.TitleCode == "" || this.generalBooking.TitleCode == undefined) {
                this.IsTitleRed = true;
            }
            else {
                this.IsTitleRed = false;
            }
        }
    }
    ValidateAlternateType() {
        if (this.IsReqAlternateType == true) {
            this.generalBooking.AlternateType = this.AlternateType;
            if (this.generalBooking.AlternateType == "null" || this.generalBooking.AlternateType == "" || this.generalBooking.AlternateType == undefined) {
                this.AlternateTypeRed = true;
            }
            else {
                this.AlternateTypeRed = false;
            }
        }
    }

    ValidateAlternateNo() {
        if (this.IsReqAltNO == true ) {
            if (this.generalBooking.AlternateNo == null || this.generalBooking.AlternateNo == "" ||
                this.generalBooking.AlternateNo == undefined) { 
                this.AlternateNoRed = true;
                this.AlternateNoForthirty = true;
            }
            else {
                this.AlternateNoForthirty = false;
                if (this.generalBooking.AlternateNo.toString().length === Number(this.CPRNOlength))
                {
                    this.AlternateNoRed = false;
                }
            }
        }
    }
    ValidateDob() {
        if (this.IsReqDob == true) {
            if ((this.EnteredDateofBirth == null || this.EnteredDateofBirth == "" || this.EnteredDateofBirth == undefined) && !this.generalBooking.IsDateEnteredManually) {
                this.IsDobRed = true;
            }
            else {
                this.IsDobRed = false;
            }
        }
    }

    ValidateGender() {

        if (this.IsReqGender == true) {
            if (this.generalBooking.Sex == "null" || this.generalBooking.Sex == undefined || this.generalBooking.Sex == "") {
                this.IsGenderRed = true;
            }
            else {
                this.IsGenderRed = false;
            }
        }
    }
    onKey(event) {
        if (event.inputType != "deleteContentBackward") {
            if (event.target.value.length == 2 || event.target.value.length == 5) {
                event.target.value = event.target.value + "/";
            }

            else if (event.target.value.length == 10 || event.target.value.length > 10) {
                event.preventDefault();
                event.target.value = event.target.value.substr(0, 10);
                var y = event.target.value.substr(0, 2);
                var y1 = +y;
                var x = event.target.value.substr(3, 2);
                var x1 = +x;
                var z = event.target.value.substr(6, 4);
                var z1 = +z;
                if (x1 > 12 || z1 > this.today.getFullYear() || y1 > 31) {
                    this.ValidDobValidityDate = false;
                }
                if (x1 == 2) {
                    this.ValidDobValidityDate = (y1 <= 28 ? true : false);
                }
            }
        }
        this.generalBooking.IsDateEnteredManually = true;
    }

    onAlternateTypeChange(event) {
        this.selectedAltType = event;
        this.generalBooking.AlternateNo = "";
       
       
        if (this.HospitalName == "JNH") {
            if (event == "9" || event == "14") {
                this.IsAlternateNoNumeric = false;
                this.OtherValue = this.AlternateNolength;
            }
            else {
                this.IsAlternateNoNumeric = true;
                this.IDvalue = this.CPRNOlength;
            }
        }
        else if (this.HospitalName == "IBN") {
            if (event == "6") {
                this.IsAlternateNoNumeric = false;
                this.OtherValue = this.AlternateNolength;
            }
            else {
                this.IsAlternateNoNumeric = true;
                this.IDvalue = this.CPRNOlength;
            }
        }
        else {
            if (event == "8" || event == "10") {
                this.IsAlternateNoNumeric = true;
            }
            else {
                this.IsAlternateNoNumeric = false;
                this.OtherValue = this.AlternateNolength;
            }
        }
        if (event == "9") {
            this.OtherValue = '15';
            this.IsAlternateNoNumeric = false;
        }
    }

    onTitlechange(event) {
        if (event == "000001") {
            this.generalBooking.Sex = "M";
        }

        else if (event == "000003" || event == "000002") {
            this.generalBooking.Sex = "F";
        }

        else {
            this.generalBooking.Sex = "";
        }
    }


    AlternateNoChanged(event) {
        if (this.selectedAltType == "9" || this.selectedAltType == "14" && this.HospitalName == "JNH") {
          
            if (event.target.value.length < 1) {
                this.AlternateNoForthirty = true;
            }
            else {
                this.AlternateNoRed = false;
                this.AlternateNoForthirty = false;
            }
        }
        else if (this.selectedAltType == "6" && this.HospitalName == "IBN") {
           
            if (event.target.value.length < 1) {
                this.AlternateNoForthirty = true;
            }
            else {
                this.AlternateNoRed = false;
                this.AlternateNoForthirty = false;
            }
        }
        else {
            if (event.target.value.length > Number(this.CPRNOlength) || event.target.value.length != Number(this.CPRNOlength)) {
                this.AlternateNoRed = true;
                this.IDvalue=this.CPRNOlength;
            }
            else {
                this.AlternateNoRed = false;
            }
        }

    }

    LoadingAfterPayment(Querynumber: string) {
        //this.loading = true;
        //if (this.generalBooking.CaptureData == "CAPTURED")
        //    this.Alertpayment.open();
        this.AppointmentComplted = true;
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this._bookingService.AfterPaymentConfirmationGuest(this.generalBooking, userData)
            .subscribe(
            s => {
                //if (this.generalBooking.CaptureData == "CAPTURED")
                //    this.Alertpayment.close();
                this.AppointmentComplted = false;
                    if (s.isValid == true) {
                        this.PayedDeptName = s.DeptName;
                        this.PayedDoctorName = s.DoctorName;
                        this.PayedPayAmount = s.PayAmount;
                        this.PayedSlot = s.Slot;
                        this.Printurl = s.Printurl;
                        this.transactionNo = s.transaction_id;
                        this.AppointmentNo = s.AppointmentNo;
                        this.ReceiptNo = s.ReceiptNo;
                        this.PatientId = s.PatientId;
                        this.InstructionEng = s.InstructionEng;
                        this.InstructionArabic = s.InstructionArabic;
                        this.trackid = s.trackid;

                        this.ClinicName = s.ClinicName;
                        this.CompanyPostBox = s.CompanyPostBox;
                        this.CompanyAddress = s.CompanyAddress;
                        this.CompanyPhoneNumber = s.CompanyPhoneNumber;
                        this.CompanyFax = s.CompanyFax;
                        this.CompanyEmail = s.CompanyEmail;
                        this.CompanyLinkEmail = s.CompanyLinkEmail;
                        this.AppointmentDate = s.AppointmentDate;
                        this.TokenNo = s.TokenNo;
                        if (this.TokenNo == undefined || this.TokenNo == "" || this.TokenNo == "")
                            this.IsTokenNo = false;
                        else
                            this.IsTokenNo = true;

                        this.HelpLineNo = s.HelpLineNo;
                        if (this.HelpLineNo == undefined || this.HelpLineNo == "" || this.HelpLineNo == "")
                            this.IsHelpLineNo = false;
                        else
                            this.IsHelpLineNo = true;
                        this.PrintPatientName = s.PatientName;
                        this.CPRNONumber = s.CPRNO;                    
                       // this.Alertpayment.close();

                        this.IsBookingConfirmedPayment = true;
                        this.isValidPayment = true;
                        //if (this.IsBookingConfirmedPayment == true) {
                        //    if (this.generalBooking.CaptureData == "CAPTURED")
                        //        this.Alertpayment.close();
                        //}
                        this.BookingConfirmedPayment.open();
                    }
                    else {
                        this.IsHelpLineNo = false;
                        
                        this.IsBookingConfirmedPayment = true;
                        //if (this.IsBookingConfirmedPayment == true) {
                        //    if (this.generalBooking.CaptureData == "CAPTURED")
                        //        this.Alertpayment.close();
                        //}
                        this.isValidPayment = false;
                        this.PayedPayAmount = s.PayAmount;
                        this.AppointmentDate = s.AppointmentDate;
                        this.trackid = s.trackid;
                        this.transactionNo = s.transaction_id;
                        if (this.transactionNo == undefined || this.transactionNo == "" || this.transactionNo == "")
                            this.IsTransaction = false;
                        else
                            this.IsTransaction = true;

                        if (s.result == "CAPTURED") {
                            //this.Alertpayment.close();
                            this.PaymentErroMsg = "Payment success, we are unable to print the receipt no.  Please contact hospital.";
                        }
                        else if (s.result == "NOT+CAPTURED" || s.result =="NOTCAPTURE")
                            this.PaymentErroMsg = "Given card details are not correct. We are unable to process your payment. Please try again";
                        else if (s.result == "HOST+TIMEOUT")
                            this.PaymentErroMsg = "Time out. We are unable to process your payment. Please try again";
                        else if (s.result == "CANCELLED") {
                            this.PaymentErroMsg = "Your process has been cancelled. We are unable to process your payment. Please try again";
                        }
                        else if (s.result == "DENIED+BY+RISK")
                            this.PaymentErroMsg = "Given card details are not correct. We are unable to process your payment. Please try again";
                        else
                            this.PaymentErroMsg = "We are unable to process your appointment.Please try again";
                        this.BookingConfirmedPayment.open();


                    }
                    

                },
                err => {
                    this.loading = false;
                    this.AppointmentComplted = false;
                    //if (this.generalBooking.CaptureData == "CAPTURED")
                    //    this.Alertpayment.close();
                    console.log("Error while getting data...");
                });
    }


    LoadDepartments() {
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this.loading = true;
        //if (this.generalBooking.CaptureData == "CAPTURED") {
        //    if (this.Alertpayment.visible == true)
        //        this.Alertpayment.close();
        //}
        this._bookingService.getDepartmentsGuest(userData, this.generalBooking.LocationId)
            .subscribe(
                p => {
                    if (p != null) {
                        this.depts = p.Departments;
                        this.BookingType = p.BookingType;
                        this.PaymentType = p.PaymentType;
                        this.ISSelfPayOption = p.ISSelfPayOption;
                        if (p.ISReqDocOption == "TRUE")
                            this.ISReqDocOption = true;
                        else
                            this.ISReqDocOption = false;
                        if (p.ISDocDepartOption != null)
                            this.ISDocDepartOption = p.ISDocDepartOption;
                        this.GuestNewPatientReq = p.GuestNewPatientReq;
                        if (p.DefaultDept != null)
                            this.generalBooking.departmentId = p.DefaultDept;
                        if (this.router.parseUrl(this.router.url).queryParams["result"] == "CANCELED")
                            this.generalBooking.departmentId = localStorage.getItem("SelectDeptId");
                        this.CPRNOlength = p.DefaultCPRNOLength;
                        this.IsDefaultBackVisible = p.DefaultBackVisible;
                        this.IsProceedPayNow = p.IsProceedPayNow;
                        if (p.IsProceedPayNow == "FALSE")
                            this.IsProceedPaybutton = false;
                        else
                            this.IsProceedPaybutton = true;
                        if (Number(this.CPRNOlength) == 9)
                            this.mobilePlaceHolder = "Enter mobile no. in Bahrain(Without +973)";
                        else
                            this.mobilePlaceHolder = "Enter mobile no. in Kuwait(Without +965)";

                        if (this.BookingType == "TOKEN")
                            this.mobilePlaceHolder = "Enter mobile no";
                       
                        this.PortalDesc = p.PortalDesc;
                      
                        if (p.PortalDesc == "KIOSK" || this.KioskORPortal== "KIOSK") {
                            this.IsPortal = false;
                            this.IsDownload = false;
                            this.BackMenu = "Back To Menu";
                        }
                        else if (p.PortalDesc == "PORTAL" || this.KioskORPortal == "PORTAL") {
                            this.IsPortal = true;
                            this.IsDownload = true;
                            this.BackMenu = "Back To Login";
                        }
                        else {
                            this.IsPortal = false;
                            this.IsDownload = true;
                            this.BackMenu = "Back To Login";
                        }
                        this.IsSearchValue = p.IsSearch;
                        if (this.IsSearchValue == "TRUE")
                            this.disableback = true;

                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting department data...");
                });
    }

    ChosenSlotValue(slotValue) {
        this.loading = true;

        if (slotValue.value != "B" && slotValue.value != "L" && this.BookingType == "SLOT") {
            this.isSlotValueChosen = true;
            this.slotErrorMessage = "NO";
            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
            this.generalBooking.scheduledStartTime = slotValue.key;
            this.selectedSlotClass = this.generalBooking.scheduledStartTime;
            this.generalBooking.SessionCode = slotValue.SessionCode;
            this.generalBooking.CLINIC_CODE = slotValue.ClinicCode;

            for (var i = 0; i < this.timeSlotsArray.length; i++) {
                if (this.timeSlotsArray[i].key == slotValue.key) {
                    this.chosenSlotValue = i;
                }
            }
            if (this.chosenSlotValue != (this.timeSlotsArray.length - 1)) {
                this.generalBooking.scheduledEndTime = this.timeSlotsArray[this.chosenSlotValue + 1].key;
            }
            else {
                this.generalBooking.scheduledEndTime = this.scheduledEndTime;
            }
            this.generalBooking.BookingStatus = "B";
            this.generalBooking.ScreenName = "GA";
            this.checkcontrolbook = true;
            this.loading = false;
        }
        else {
            this.loading = false;
            this.isSlotValueChosen = false;
            this.checkcontrolbook = false;
            this.slotErrorMessage = "NO";
        }
    }



    LoadBookingReports() {
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        userData.FromTime = "00:00";
        userData.ToTime = "23:00";
        userData.DateFrom = this.date;
        userData.DepartmentID = "NULL";
        userData.DayCode = this.activebutton.toString();


        if (this.router.parseUrl(this.router.url).queryParams["result"] == "CANCELED") {
            userData.DateFrom = localStorage.getItem("SelectDate");
            var ddd = localStorage.getItem("SelectDate");
            var date_components = ddd.split("/");
            this.appDate = { date: { year: date_components[2], month: date_components[1], day: date_components[0] } };
           
            this.activebutton = Number(localStorage.getItem("SelectDay"));
          
            userData.DepartmentID = localStorage.getItem("SelectDeptId");
        }

      
        this._bookingService.getBookingReportsGuest(userData)
            .subscribe(
                p => {
                    if (p != null) {
                        
                        this.dataSource = p.BookingList;
                        let queryStringCount: number = this.router.url.indexOf("?");
                        if ((userData.DepartmentID != "" || userData.DepartmentID.toString() != "NULL") && queryStringCount > 0 && p.BookingList.length == 0) {
                            this.IsPatientValid.open();
                            this.IsPatientValidFailed = true;
                            this.message = "There is no slot for today.  Please try other day.";
                        }
                       
                        this.dataSourceOriginal = this.dataSource;
                      
                        this.buildGrid(this.dataSource);
                        
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting booking data...");
                });
    }

    DoctorSearch() {
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);

        userData.FromTime = "00:00";
        userData.ToTime = "23:00";


        userData.DateFrom = this.date;
        userData.DepartmentID = "0";
        userData.DayCode = this.activebutton.toString();
        this.generalBooking.departmentId = "0";
        userData.DoctorName = this.doctorName;
        userData.LocationId = this.generalBooking.LocationId;
        this.loading = true;
        this._bookingService.SearchBookingReportsGuest(userData)
            .subscribe(
                p => {
                    if (p != null) {
                        this.dataSource = p.BookingList;
                        this.dataSourceOriginal = this.dataSource;
                        this.buildGrid(this.dataSource);
                        this.loading = false;
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting booking data...");
                });
    }

    showBookingSlots(drCode) {
        this.SlotVisible = true;
        //this.loading = true;
        this.timeSlotsArray = [];
        this.selectedSlotClass = "";
        this.selectedSlotDrCode = drCode;
        this.TermsChecked = false;
        this.clearPatientValues();
        this.isSlotValueChosen = false;
        this.slotErrorMessage = "NO"
        this.IsPatientcountone = false;
        this.IsMobileText = false;
        this.appDate1 = this.appDate;
        this.generalBooking.consultationFee = "0";
        if (this.ISSelfPayOption == "TRUE") {
            this.AlertBookPopup.open();
            this.IsAlertBookPopup = true;
        }

        var userData: UserData = new UserData("0", "", "", false);
        for (var i = 0; i < this.dataSource.length; i++) {
            if (this.dataSource[i].DoctorCode == drCode) {
                if (this.bookingFilter.FromDate == undefined) {
                    this.bookingFilter.FromDate = this.date;
                }
                if (this.bookingFilter.ToTime == undefined) {
                    this.bookingFilter.ToTime = "23";
                }
                if (this.bookingFilter.FromTime == undefined) {
                    this.bookingFilter.FromTime = "00";
                }
                this.generalBooking.date = this.bookingFilter.FromDate;
                this.generalBooking.department = this.dataSource[i].DeptName;
                this.generalBooking.departmentIdofChosenDoctor = this.dataSource[i].DEPT_CODE;
                this.generalBooking.SLOT = this.dataSource[i].SLOT;
                this.generalBooking.doctorId = this.dataSource[i].DoctorCode;
                this.generalBooking.doctorName = this.dataSource[i].DoctorName;
                this.generalBooking.NativeDoctorName = this.dataSource[i].NativeDoctorName;
                this.generalBooking.NativeDeptName = this.dataSource[i].NativeDeptName;
                this.generalBooking.DisplayOrder = Number(this.dataSource[i].DisplayOrder);
                this.generalBooking.IS_BOOK_ALLOW = this.dataSource[i].IS_BOOK_ALLOW
                this.generalBooking.Id = "0";
                this.generalBooking.speciality = this.dataSource[i].Speciality;
                this.generalBooking.scheduledEndTime = this.bookingFilter.ToTime;
                this.generalBooking.scheduledStartTime = this.bookingFilter.FromTime;
                this.generalBooking.token = this.dataSource[i].Token;
                this.generalBooking.dayCode = this.activebutton;
                this.generalBooking.ImageByte = "";
                this.generalBooking.ImageByte = this.dataSource[i].ImageByte;
                this.generalBooking.SlotPeriod = this.dataSource[i].SlotPeriod;
                this.generalBooking.StartTime = this.dataSource[i].StartTime;
                this.generalBooking.EndTime = this.dataSource[i].EndTime;
                this.generalBooking.SessionCode = this.dataSource[i].SessionCode;
                this.generalBooking.CLINIC_CODE = this.dataSource[i].CLINIC_CODE;
                this.scheduledEndTime = this.dataSource[i].EndTime.toString().split('T')[1].slice(0, 5);
                this.scheduledStartTime = this.dataSource[i].StartTime.toString().split('T')[1].slice(0, 5);
                this.DoctorsSlotTiming = this.dataSource[i].DoctorTime;
                this.generalBooking.IsPortalKiosk = this.KioskORPortal;
            }
        }
        localStorage.setItem("SelectDeptId", this.generalBooking.departmentIdofChosenDoctor);
        localStorage.setItem("SelectDate", this.generalBooking.date);
        localStorage.setItem("SelectDay", this.generalBooking.dayCode.toString());
        localStorage.setItem("MainDeptId", this.generalBooking.departmentIdofChosenDoctor);
        localStorage.setItem("MainDate", this.generalBooking.date);
        localStorage.setItem("MainDay", this.generalBooking.dayCode.toString());
        this._bookingService.getConfirmBookingStatusGuest(this.generalBooking, userData)
            .subscribe(
                p => {
                   // this.loading = false;
                    if (p.SessionExpiry) {
                        //this.loading = false;
                        this._SecurityService.errorMessage = "";
                        if (p.doctorStatus == "YES") {
                            this.generalBooking.totalTimeSlots = p.totalTimeSlots;
                            if (p.consultationChargesMessage == "") {
                                this.generalBooking.consultationFee = p.consultationFee;
								this.generalBooking.NO_CHARGE = p.NO_CHARGE;
                                this.IsConfirmPay = true;
                            }
                            else {
                                this.generalBooking.consultationFee = "0.00";
                                this.IsConfirmPay = false;
                            }

                            if (this.IsConfirmPay == true)
                                this.payLaterStatus = p.PaymentLaterStatus;
                            else
                                this.payLaterStatus = "TRUE";

                            if (this.BookingType == "SLOT") {

                                this.GetSplittedTimeSlots(this.generalBooking.totalTimeSlots, drCode);
                                if (this.ISSelfPayOption == "TRUE") {
                                }
                                else {
                                    if (this.DoctorsSlotTiming != null && this.DoctorsSlotTiming != "" && this.DoctorsSlotTiming != undefined) {
                                        this.viewModelPopup.open();
                                        this.enableHadiPopup = "YES";
                                    }
                                    else {
                                        this.IsPatientValidFailed = true;
                                        this.IsPatientValid.open();
                                        this.message = "No available slot for the selected date. Choose another date";
                                    }
                                }
                            }
                            else {
                                this.GetSplittedTimeSlots(this.generalBooking.totalTimeSlots, drCode);
                                if (this.ISSelfPayOption == "TRUE") {
                                }
                                else {
                                    if (this.DoctorsSlotTiming != null && this.DoctorsSlotTiming != "" && this.DoctorsSlotTiming != undefined) {
                                        this.viewModelPopup.open();
                                        this.enableJnhPopup = "YES";
                                    }
                                    else {
                                        this.IsPatientValidFailed = true;
                                        this.IsPatientValid.open();
                                        this.message = "No available Token for the selected date. Choose another date";
                                    }
                                }
                            }
                            this.generalBooking.ServiceCode = p.ServiceCode;
                            this.isValid = true;
                        }
                        else {
                            this.isValid = false;
                        }
                    }

                    else if (!p.SessionExpiry) {
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        //this.router.navigate(["/Login"]);
                        this.loading = false;
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting data...");
                });
    }

    showBookingSlots1(drCode) {
        this.SlotVisible = true;
        var userData: UserData = new UserData("0", "", "", false);
      this.loading = true;
        this.timeSlotsArray = [];
         /* this.selectedSlotClass = "";
        this.selectedSlotDrCode = drCode;
        this.TermsChecked = false;
        this.clearPatientValues();
        this.isSlotValueChosen = false;
        this.slotErrorMessage = "NO"
        this.IsPatientcountone = false;
        this.IsMobileText = false;
        this.generalBooking.consultationFee = "0";
        if (this.ISSelfPayOption == "TRUE") {
            this.AlertBookPopup.open();
            this.IsAlertBookPopup = true;
        }

        var userData: UserData = new UserData("0", "", "", false);
        for (var i = 0; i < this.dataSource.length; i++) {
            if (this.dataSource[i].DoctorCode == drCode) {*/
                if (this.bookingFilter.FromDate == undefined) {
                    this.bookingFilter.FromDate = this.date;
                }
                if (this.bookingFilter.ToTime == undefined) {
                    this.bookingFilter.ToTime = "23";
                }
                if (this.bookingFilter.FromTime == undefined) {
                    this.bookingFilter.FromTime = "00";
                }
                this.generalBooking.date = this.bookingFilter.FromDate;
                this.generalBooking.dayCode = this.activebutton1;
                /*this.generalBooking.department = this.dataSource[i].DeptName;
                this.generalBooking.departmentIdofChosenDoctor = this.dataSource[i].DEPT_CODE;
                this.generalBooking.SLOT = this.dataSource[i].SLOT;
                this.generalBooking.doctorId = this.dataSource[i].DoctorCode;
                this.generalBooking.doctorName = this.dataSource[i].DoctorName;
                this.generalBooking.NativeDoctorName = this.dataSource[i].NativeDoctorName;
                this.generalBooking.NativeDeptName = this.dataSource[i].NativeDeptName;
                this.generalBooking.DisplayOrder = Number(this.dataSource[i].DisplayOrder);
                this.generalBooking.IS_BOOK_ALLOW = this.dataSource[i].IS_BOOK_ALLOW
                this.generalBooking.Id = "0";
                this.generalBooking.speciality = this.dataSource[i].Speciality;
                this.generalBooking.scheduledEndTime = this.bookingFilter.ToTime;
                this.generalBooking.scheduledStartTime = this.bookingFilter.FromTime;
                this.generalBooking.token = this.dataSource[i].Token;
                this.generalBooking.dayCode = this.activebutton;
                this.generalBooking.ImageByte = "";
                this.generalBooking.ImageByte = this.dataSource[i].ImageByte;
                this.generalBooking.SlotPeriod = this.dataSource[i].SlotPeriod;
                this.generalBooking.StartTime = this.dataSource[i].StartTime;
                this.generalBooking.EndTime = this.dataSource[i].EndTime;
                this.generalBooking.SessionCode = this.dataSource[i].SessionCode;
                this.generalBooking.CLINIC_CODE = this.dataSource[i].CLINIC_CODE;
                this.scheduledEndTime = this.dataSource[i].EndTime.toString().split('T')[1].slice(0, 5);
                this.scheduledStartTime = this.dataSource[i].StartTime.toString().split('T')[1].slice(0, 5);
                this.DoctorsSlotTiming = this.dataSource[i].DoctorTime;
            }
        }*/
        localStorage.setItem("SelectDeptId", this.generalBooking.departmentIdofChosenDoctor);
        localStorage.setItem("SelectDate", this.generalBooking.date);
        localStorage.setItem("SelectDay", this.generalBooking.dayCode.toString());
        this._bookingService.getConfirmBookingStatusGuest(this.generalBooking, userData)
            .subscribe(
                p => {
                    this.loading = false;
                    if (p.SessionExpiry) {
                        this._SecurityService.errorMessage = "";
                        if (p.doctorStatus == "YES") {
                            this.generalBooking.totalTimeSlots = p.totalTimeSlots;
                            this.DoctorsSlotTiming = p.DoctorSlot;
                            this.generalBooking.SLOT = p.Totalslot;
                            if (p.consultationChargesMessage == "") {
                                this.generalBooking.consultationFee = p.consultationFee;
                                this.IsConfirmPay = true;
                            }
                            else {
                                this.generalBooking.consultationFee = "0.00";
                                this.IsConfirmPay = false;
                            }

                            if (this.IsConfirmPay == true)
                                this.payLaterStatus = p.PaymentLaterStatus;
                            else
                                this.payLaterStatus = "TRUE";

                            if (this.BookingType == "SLOT") {

                                this.GetSplittedTimeSlots(this.generalBooking.totalTimeSlots, drCode);
                                if (this.ISSelfPayOption == "TRUE") {
                                }
                                else {
                                    if (this.DoctorsSlotTiming != null && this.DoctorsSlotTiming != "" && this.DoctorsSlotTiming != undefined) {
                                        this.viewModelPopup.open();
                                        this.enableHadiPopup = "YES";
                                    }
                                    else {
                                        this.IsPatientValidFailed = true;
                                        this.IsPatientValid.open();
                                        this.message = "No available slot for the selected date. Choose another date";
                                    }
                                }
                            }
                            else {
                                this.GetSplittedTimeSlots(this.generalBooking.totalTimeSlots, drCode);
                                if (this.ISSelfPayOption == "TRUE") {
                                }
                                else {
                                    if (this.DoctorsSlotTiming != null && this.DoctorsSlotTiming != "" && this.DoctorsSlotTiming != undefined) {
                                        this.viewModelPopup.open();
                                        this.enableJnhPopup = "YES";
                                    }
                                    else {
                                        this.IsPatientValidFailed = true;
                                        this.IsPatientValid.open();
                                        this.message = "No available Token for the selected date. Choose another date";
                                    }
                                }
                            }
                            this.generalBooking.ServiceCode = p.ServiceCode;
                            this.isValid = true;
                        }
                        else {
                            this.isValid = false;
                        }
                    }

                    else if (!p.SessionExpiry) {
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                       // this.router.navigate(["/Login"]);
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting data...");
                });
    }
//    AlertpaymentCancel(){
//        this.Alertpayment.close();
//}
    AlterBookCancel() {

        if (this.BookingType == "SLOT") {
            if (this.DoctorsSlotTiming != null && this.DoctorsSlotTiming != "" && this.DoctorsSlotTiming != undefined) {
                this.viewModelPopup.open();
                this.enableHadiPopup = "YES";
            }
            else {
                this.IsPatientValidFailed = true;
                this.IsPatientValid.open();
                this.message = "No available slot for the selected date. Choose another date";
            }
        }
        else {
            if (this.DoctorsSlotTiming != null && this.DoctorsSlotTiming != "" && this.DoctorsSlotTiming != undefined) {
                this.viewModelPopup.open();
                this.enableJnhPopup = "YES";
            }
            else {
                this.IsPatientValidFailed = true;
                this.IsPatientValid.open();
                this.message = "No available Token for the selected date. Choose another date";
            }
        }
    }

    BookRequestCancel() {
        this.viewModelPopup.close();
        this.generalBooking.totalTimeSlots = [];
        this.DoctorsSlotTiming = "";
        this.generalBooking.SLOT = "";
        this.generalBooking.date = localStorage.getItem("MainDate");
        this.activebutton1 = Number(localStorage.getItem("MainDay"));
        this.generalBooking.dayCode = Number(localStorage.getItem("MainDay"));
        var ddd = localStorage.getItem("MainDate");
        var date_components = ddd.split("/");
        this.appDate1 = { date: { year: date_components[2], month: date_components[1], day: date_components[0] } };
        this.date = localStorage.getItem("MainDate");
        this.bookingFilter.FromDate = this.date;
    }

    PopupOk() {
        this.generalBooking.date = localStorage.getItem("MainDate");
        this.activebutton1 = Number(localStorage.getItem("MainDay"));
        this.generalBooking.dayCode = Number(localStorage.getItem("MainDay"));
        var ddd = localStorage.getItem("MainDate");
        var date_components = ddd.split("/");
        this.appDate1 = { date: { year: date_components[2], month: date_components[1], day: date_components[0] } };
        this.date = localStorage.getItem("MainDate");
        this.bookingFilter.FromDate = this.date;
    }
    SlotCancel() {
        this.loading = true;
        this.slotErrorMessage = "NO";
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);

        this.selectedSlotClass = this.generalBooking.scheduledStartTime;

        this.generalBooking.BookingStatus = "N";
        this.generalBooking.ScreenName = "GA";
        this._bookingService.updateChosenSlotGuest(this.generalBooking, userData)
            .subscribe(
                p => {
                    this.loading = false;
                    if (p.message.length != 0) {
                        this.selectedSlotClass = "";
                    }
                    else {
                        this.selectedSlotClass = "";
                        this.slotBookingFailed = false;
                        this.slotAllotment.close();
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting department data...");
                });

        this.viewModelPopup.close();
    }

    GetSplittedTimeSlots(timeslotArray, drCode) {
        this.selectedSlotDrCode = drCode;
        var testnew = 0;
        this.JnhFirstSlot = "";
        for (var i = 0; i < timeslotArray.length; i++) {
            let kv: Bookingkeyvaluepair = new Bookingkeyvaluepair();
            kv.key = timeslotArray[i].SlotTime;
            if (this.generalBooking.SLOT == "Total Slot : 0") {
                kv.value = "B";
            }
            else {
                kv.value = timeslotArray[i].SlotStatusValue;
            }
            if (kv.value == "N" && testnew == 0) {
                this.JnhFirstSlot = kv.key;
                testnew = 1;
                this.generalBooking.SessionCode = timeslotArray[i].SessionCode;
                this.generalBooking.CLINIC_CODE = timeslotArray[i].ClinicCode;
            }

            kv.slotMessage = this.slotMessage;
            kv.SessionCode = timeslotArray[i].SessionCode;
            kv.ClinicCode = timeslotArray[i].ClinicCode;
            this.timeSlotsArray.push(kv);
        }
    }

    onDateChanged(event: IMyDateModel) {
        if (event != undefined) {
            if (event.formatted != null && event.formatted != undefined && event.formatted != "") {    
                if (this.HospitalName == "JNH") {
                    var dt = new Date(event.date.year, event.date.month - 1, event.date.day+1);
                    this.activebutton = dt.getDay()+1;
                }
                else {
                    var dt = new Date(event.date.year, event.date.month - 1, event.date.day);
                    this.activebutton = dt.getDay();
                }
                this.bookingFilter.FromDate = event.formatted.toString();
                this.bookingFilter.FromDate = this.bookingFilter.FromDate.replace(".", "/");
                this.date = this.bookingFilter.FromDate;
               // this.appDate1 = this.date;//{ date: { year: event.date.year, month: event.date.month + 1, day: event.date.day } };
            }
            else {
                var d = new Date();
                this.appDate = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
               // this.appDate1 = this.appDate;// { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
                this.activebutton = d.getDay();
                this.clickedDate = ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear();
                this.bookingFilter.FromDate = this.clickedDate;
                this.date = this.bookingFilter.FromDate;
            }
        }
      //  this.appDate1 = this.appDate;
        this.activebutton1 = this.activebutton;
        this.LoadFilterReports();
    }

    onDateChanged1(event: IMyDateModel) {
        this.SlotVisible = false;
        if (event != undefined) {
            if (event.formatted != null && event.formatted != undefined && event.formatted != "") {
                var dt = new Date(event.date.year, event.date.month - 1, event.date.day);
                this.activebutton1 = dt.getDay();

                this.bookingFilter.FromDate = event.formatted.toString();
                this.bookingFilter.FromDate = this.bookingFilter.FromDate.replace(".", "/");
                this.date = this.bookingFilter.FromDate;
            }
            else {
                var d = new Date();
                this.appDate1 = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
                this.activebutton1 = d.getDay();
                this.clickedDate = ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear();
                this.bookingFilter.FromDate = this.clickedDate;
                this.date = this.bookingFilter.FromDate;
            }
        }
        //  this.LoadFilterReports();
        this.showBookingSlots1(this.generalBooking.doctorId);
    }

    setTab(val: number) {
        if (val != 9) {
            var d = new Date();
            if (d.getDay() > val) {
                d.setDate(d.getDate() + (7 - d.getDay()) + val)
            }
            else {
                d.setDate(d.getDate() + (val - d.getDay()));
            }
            this.appDate = { date: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() } };
           // this.appDate1 = this.appDate;//{ date: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() } };
            this.activebutton = val;
            this.activebutton1 = val;
            this.clickedDate = ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear();
            this.bookingFilter.FromDate = this.clickedDate;
            this.date = this.bookingFilter.FromDate;
            this.bookingFilter.DAYS = val.toString();

        }

        else {
            this.appDate = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
            this.activebutton = val;
        }
        this.LoadFilterReports();

    }

    setTab1(val: number) {
        this.SlotVisible = false;
        if (val != 9) {
            var d = new Date();
            if (d.getDay() > val) {
                d.setDate(d.getDate() + (7 - d.getDay()) + val)
            }
            else {
                d.setDate(d.getDate() + (val - d.getDay()));
            }
            this.appDate1 = { date: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() } };
            this.activebutton1 = val;
            this.clickedDate = ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear();
            this.bookingFilter.FromDate = this.clickedDate;
            this.date = this.bookingFilter.FromDate;
            this.bookingFilter.DAYS = val.toString();

        }

        else {
            this.appDate1 = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
            this.activebutton1 = val;
        }
        // this.LoadFilterReports();
        this.showBookingSlots1(this.generalBooking.doctorId);

    }

    update(slider, event) {
       
        slider.onUpdate = event;
    }

    finish(slider, event) {
        
        slider.onFinish = event;
        if (event) {
            this.bookingFilter.FromTime = event.from + ":00";
            this.bookingFilter.ToTime = event.to + ":00";
            this.LoadFilterReports();
        }
    }

    OnDepartmentChange() {
        this.LoadFilterReports();
    }

    LoadFilterReports() {
        var userData: UserData = this.buildBookingfilter();
        this.loading = true;
        this._bookingService.getFilterReportsForGuest(userData)
            .subscribe(
            p => {
                    if (p != null) {
                        this.loading = false;
                        
                        this.dataSource = p.BookingList;
                        this.buildGrid(this.dataSource);
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting booking data...");
            });
        
    }

    buildBookingfilter(): UserData {
        if (this.bookingFilter.FromDate == undefined) {
            this.bookingFilter.FromDate = this.date;
        }
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        if (this.bookingFilter) {
            userData.DateFrom = this.bookingFilter.FromDate;
            userData.DepartmentID = this.bookingFilter.DEPT_CODE;
            userData.FromTime = this.bookingFilter.FromTime;
            userData.ToTime = this.bookingFilter.ToTime;
            userData.DayCode = this.activebutton.toString();
            userData.LocationId = this.generalBooking.LocationId;
            this.generalBooking.LocationId = this.generalBooking.LocationId;
            this.generalBooking.departmentId = this.generalBooking.departmentId == null ? "0" : this.generalBooking.departmentId;
            userData.DepartmentID = this.generalBooking.departmentId;
            if (this.IsLocationChange == true) {
                // this.generalBooking.departmentId = this.generalBooking.departmentId == null ? "0" : this.generalBooking.departmentId;	
                userData.DepartmentID = "NULL";
            }
            let queryStringCount: number = this.router.url.indexOf("?");
            if ((userData.DepartmentID != "" || userData.DepartmentID.toString() != "NULL") && queryStringCount > 0 && userData.DepartmentID.toString() != "0") {
                let url: string = this.router.url.substring(0, this.router.url.indexOf("?"));
                this.router.navigate([url], { queryParams: {} });
            }
           
        }
        return userData;
    }

    public buildGrid(Data) {
        this.loading = true;
        try {
            this.buildColumn();

            var dgrid = jQuery("#grdBookings").data("kendoGrid");
            if (dgrid) {
                $('#grdBookings').data().kendoGrid.destroy();
                $('#grdBookings').empty();
            }
            jQuery('#grdBookings').kendoGrid({
                editable: false,
                filterable: true,
                pageable: {
                    pageSizes: [5, 10, 25, 50, 100]
                },
                scrollable: false,
                sortable: true,
                columns: this.columns,
                dataBinding: this.databinding,
                dataSource: {
                    data: Data,
                    
                    pageSize: Data != null ? 10 : 0,
                    sort: [
                        {
                            field: "DisplayOrder", dir: "asc"
                        },
                        {
                            field: "DoctorName",
                            dir: "asc"
                        }],
                },
            });
            jQuery("#grdBookings").data("kendoGrid").wrapper.children(".k-grid-pager").find("span.k-input").html('All');
            var gridPage = jQuery("#grdBookings").data("kendoGrid");
            gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html('10');
            var pageSizeDropDownList = gridPage.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
            pageSizeDropDownList.bind("change", function (e: any) {
                gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html(gridPage.wrapper.children(".k-grid-pager").find("select").find('option:selected').text());
            });
            this.loading = false;
        }
        catch (ex) {
            this.handleError(ex);
        }
    }

    buildColumn(): void {
        
        this.columns = [
            {
                field: "DEPT_CODE",
                title: " ",
                template: kendo.template("#=this.buildBookingReportRow(DoctorName,NativeDoctorName,NativeDeptName, DoctorCode,DisplayOrder, DEPT_CODE, SLOT, DAYS, Qualification, Designation, Speciality, ImageByte, DeptName, DoctorType, Remarks)#").bind(this)
            }
        ];
    }

    buildBookingReportRow(DoctorName, NativeDoctorName, NativeDeptName, DoctorCode: string, DisplayOrder: number, DEPT_CODE, SLOT, DAYS, Qualification, Designation, Speciality, ImageByte, DeptName, DoctorType, Remarks) {
      
        var dept = DEPT_CODE;
       
        var drCode = DoctorCode;
        
        if (NativeDeptName != null && NativeDoctorName != null && NativeDeptName != "" && NativeDoctorName != "" && NativeDeptName != undefined && NativeDoctorName != undefined )
            var NativeDept = " <span class='doc-name green_text'> <strong style='unicode-bidi: embed'>" + '/' + NativeDoctorName + " </strong>  ( " + NativeDeptName + " ) </span>";
        else if ((NativeDeptName == null || NativeDeptName == "" || NativeDeptName == undefined) && NativeDoctorName != null && NativeDoctorName != undefined && NativeDoctorName != "")
            var NativeDept = " <span class='doc-name green_text'> <strong style='unicode-bidi: embed'>" + '/' + NativeDoctorName + " </strong></span>";
        else
            var NativeDept = " <span class='doc-name green_text'> <strong style='unicode-bidi: embed'>" + " </strong></span>";

        var Img = "data:image/JPEG;base64," + ImageByte;
        
        var l1 = "<div class='visit_wrap doc_deta_wrap'>";
        var l2 = "    <div class='doc-img-wrap'>  <img src=" + Img + " /> </div>";
        var l3 = "    <div class='doctor_date graybg pad_le130'>";
        var l4 = "     <span class='doc-name green_text'> <strong>" + DoctorName + " </strong>  ( " + DeptName + " ) </span>" + NativeDept;
        var l5 = "        <span class='pull-right font13'></span>";
       
        var l6 = "    </div>";
        var l7 = "    <div class='doc_short_desc pad_le130'>";
        var l81 = "        <span class='doc-desc' style='color: #F35933;padding:0px'> Position:" + DoctorType + " </span> ";
        var l8 = "        <span class='doc-desc'> " + Remarks + " </span> ";
       
        var l9 = "    </div>";
        var l10 = "    <div class='tot_slot_book pad_le130'>";
        var l11 = "        <span class='ttlslot green_text'>" + SLOT + "</span>";
        var l12 = "        <span class='availdays font13'> " + DAYS + " </span>";
        var l13 = "        <span class='pull-right green-bg bookbtn'  onclick=bookingGrid.showBookingSlots('" + DoctorCode + "')> <i class='fa fa-calendar-plus-o' aria-hidden='true'></i> Book Appointment </span>";
        var l16 = "        <span class='pull-right green-bg bookbtn disableBtn'> <i class='fa fa-calendar-plus-o' aria-hidden='true'></i> Book Appointment </span>";
        var l14 = "    </div>";
        var l15 = "</div>"
        if (this.activebutton == 9)
            return l1 + l2 + l3 + l4 + l5 + l6 + l7 + l81 + l8 + l9 + l10 + l11 + l12 + l16 + l14 + l15;
        else
            return l1 + l2 + l3 + l4 + l5 + l6 + l7 + l81 + l8 + l9 + l10 + l11 + l12 + l13 + l14 + l15;
    }

    databinding(e: any) {
        try {
            var grid = jQuery("#grdBookings").data("kendoGrid");
            var totalCount = grid.dataSource.total();
            var pageSizes = [{ text: "5", value: 5 }, { text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "All", value: totalCount }];
            var pagerdropdownBox = jQuery('.k-pager-sizes select[data-role="dropdownlist"]').data('kendoDropDownList');
            var pagerds = new kendo.data.DataSource({
                data: pageSizes
            });
            pagerdropdownBox.setDataSource(pagerds);
        }
        catch (e) {
           
        }
    }

    SaveAppointmentPatient(radiotextvalue) {
        this.loading = true;
        this.generalBooking.IsDocumentAttached = this.IsDocumentAttached;
        this.IsPopupPayment = false;
        
        this.generalBooking.PrivatePaymentType = "Private";
        if (radiotextvalue != undefined) {
            if (radiotextvalue ==  "selfPay") {
               
                this.generalBooking.PrivatePaymentType = "Private";
            }
            else {
               
                this.generalBooking.PrivatePaymentType = "Insured";
            }
        }

        if (this.generalBooking.Email != null && this.generalBooking.Email != "" && this.generalBooking.Email != undefined) {
            if (this.generalBooking.Email.indexOf("@") <= 0 || (this.generalBooking.Email.indexOf(".") <= 0)) {
                this.IsSelectEmailValidation = true;
            }
            else {
                this.IsSelectEmailValidation = false;
            }
        }
        else {
            this.IsSelectEmailValidation = false;
        }

        this.UploadValidation();
        if (this.IsGuestEmailReq == true) {
            if (this.generalBooking.Email == null || this.generalBooking.Email == "" || this.generalBooking.Email == undefined) {
                this.IsSelectEmailRed = true;
            }
            else {
                this.IsSelectEmailRed = false;
            }
        }
        if (this.IsPatientOBGYN == true || this.IsPatientPediatric == true) {
            this.IsPatientValidFailed = true;
            this.IsPatientValid.open();
            if (this.IsPatientOBGYN == true) {
                this.message = "Visit is Not Allowed For Male Patients in this Department.";
            }
            if (this.IsPatientPediatric == true) {
                this.message = "Patient age should be less than '15' to schedule in pediatrics costcenter.";
            }
            this.loading = false;

        }
        else {
            this.IsSearchMobileNumberRed = false;
            this.IsPatientValidFailed = false;

            if (this.generalBooking.PrivatePaymentType != null && this.generalBooking.PrivatePaymentType != undefined && this.generalBooking.PrivatePaymentType != ""
                && this.generalBooking.PrivatePaymentType == "Private" && this.generalBooking.patientId != null && this.generalBooking.patientId != ""
                && this.generalBooking.patientId != undefined && this.SearchMobileNumber != null && this.TermsChecked == true && this.IsSelectEmailValidation == false && this.IsSelectEmailRed == false
                && this.SearchMobileNumber != "" && this.SearchMobileNumber != undefined && this.CvilIdNoRed == false && this.PaymentType != "Y" && this.SearchMobileNumber.length >= 8
                && (this.IsUploadDocVisble == false || (this.IsUploadDocVisble == true && this.generalBooking.IsDocumentAttached == true)) && this.IsuploadValidationErrorMsg == false &&
                (this.IsUploadDocVisble == false ||(this.IsUploadDocVisble == true && (this.generalBooking.CivilIdFront != null && this.generalBooking.CivilIdBack != null) || (this.generalBooking.PassportFront != null || this.generalBooking.PassportBack != null)))) {
                if (this.generalBooking.consultationFee != "0" && this.generalBooking.consultationFee != "0.00" && this.generalBooking.consultationFee != undefined && this.generalBooking.consultationFee != "") {
                    this.generalBooking.buttonActivity = "Payment";
                    this.SelecterrMsg1 = "";
                    //this.Alertpayment.open();
                    this.generalBooking.MobileNo = this.SearchMobileNumber;
                    this.SubmitForm();
                    this.clearPatientValues();
                    this.clearValues();
                    this.viewModelPopup.close();
                    this.appointmentBooking = false;
                }
                else {
                    this.IsPatientValidFailed = true;
                    this.IsPatientValid.open();
                    this.message = "consultation Fee should be greater than zero.";
                }
                this.loading = false;
            }
            else if (this.generalBooking.PrivatePaymentType != null && this.generalBooking.PrivatePaymentType != undefined && this.generalBooking.PrivatePaymentType != ""
                && this.generalBooking.PrivatePaymentType == "Private" && this.generalBooking.patientId != null && this.generalBooking.patientId != ""
                && this.generalBooking.patientId != undefined && this.SearchMobileNumber != null && this.TermsChecked == true && this.IsSelectEmailValidation == false && this.IsSelectEmailRed == false
                && this.SearchMobileNumber != "" && this.SearchMobileNumber != undefined && this.CvilIdNoRed == false && this.PaymentType == "Y" && this.SearchMobileNumber.length >= 8) {
                if (this.generalBooking.consultationFee != "0" && this.generalBooking.consultationFee != "0.00" && this.generalBooking.consultationFee != undefined && this.generalBooking.consultationFee != "") {
                    var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
                    this.IsSearchMobileNumberRed = false;
                    this.IsPatientValidFailed = false;
                    var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
                    this.SelecterrMsg1 = "";
                    this.generalBooking.MobileNo = this.SearchMobileNumber;
                   // if(this.HospitalName=="IBN")
                    this._bookingService.PaymentModeSelectionGuest(this.generalBooking, userData)
                        .subscribe(
                            p => {
                                this.loading = false;
                                if (p.length != 0) {
                                    //this.Alertpayment.open();
                                    this.generalBooking.credimaxPaymentDetails = p.credimaxPaymentDetails;
                                    this.generalBooking.requestParam = p.requestParam;
                                }
                                else {

                                }
                            },
                            err => {
                                this.loading = false;
                                console.log("Error while getting department data...");
                            });
                    this.IsPopupPayment = true;
                    this.PopupPayment.open();
                }
                else {
                    this.IsPatientValidFailed = true;
                    this.IsPatientValid.open();
                    this.message = "consultation Fee should be greater than zero.";
                }
                this.loading = false;
            }
            else {
                if ((this.generalBooking.PrivatePaymentType == null || this.generalBooking.PrivatePaymentType == "" || this.generalBooking.PrivatePaymentType == undefined)
                    && (this.generalBooking.patientId == null || this.generalBooking.patientId == "" || this.generalBooking.patientId == undefined) &&
                    (this.SearchMobileNumber == null || this.SearchMobileNumber == "" || this.SearchMobileNumber == undefined)) {
                    this.IsselectPatientSearch1 = true;
                    this.SelecterrMsg1 = "Please select one patient id and enter the phone number also";
                }
                else {
                    if (this.SearchMobileNumber == null || this.SearchMobileNumber == "" || this.SearchMobileNumber == undefined) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please enter the mobile number";
                    }
                    else if (this.SearchMobileNumber.length < 8) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Mobile number should not be less than 8 digits";
                    }
                    else if (this.IsSelectEmailRed == true) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Email is Required";
                    }
                    else if (this.IsSelectEmailValidation == true) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Email is not valid";
                    }
                    else if (this.generalBooking.PrivatePaymentType == null || this.generalBooking.PrivatePaymentType == "" || this.generalBooking.PrivatePaymentType == undefined) {
                        this.IsselectPatientSearch1 = true;
                       
                        if (this.payLaterStatus == "TRUE")
                            this.SelecterrMsg1 = "Please select whether you are proceeding as 'Insured' or 'Non-insured'.";
                        else
                            this.SelecterrMsg1 = "Please select Self Pay option";
                    }
                    else if (this.generalBooking.PrivatePaymentType == "Insured" || this.generalBooking.PrivatePaymentType == "Insured" || this.generalBooking.PrivatePaymentType == "Insured") {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please select Self-Pay option";
                    }
                    else if (this.TermsChecked == false) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please select Terms and conditions option";
                    }
                    else if (this.IsUploadDocVisble == true && this.generalBooking.IsDocumentAttached == false) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please select the Document Attached option";
                    } 
                    else if (this.IsuploadValidationErrorMsg == true) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please Upload Only .jpg,.png and pdf format Files";;
                    }
                    else if (this.IsUploadDocVisble == true && this.generalBooking.CivilIdFront == null && this.generalBooking.CivilIdBack == null && this.generalBooking.PassportFront == null && this.generalBooking.PassportBack == null) {
                        this.IsselectPatientSearch1 = true;
                        if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
                            this.SelecterrMsg1 = "Please upload any one CPRNO or Passport image";
                        }
                        else {
                            this.SelecterrMsg1 = "Please upload any one Civil or Passport image";
                        }
                    }
                    else if (this.IsUploadDocVisble == true &&(this.generalBooking.CivilIdFront == null && this.generalBooking.CivilIdBack != null) || (this.generalBooking.CivilIdFront != null && this.generalBooking.CivilIdBack == null))
                    {
                         if (this.generalBooking.CivilIdFront == null && this.generalBooking.CivilIdBack != null) {
                             this.IsselectPatientSearch1 = true;
                             if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
                                 this.SelecterrMsg1 = "Please upload the CPR NO Front image";
                             }
                             else {
                                 this.SelecterrMsg1 = "Please upload the Civil ID Front image";
                             }
                            }
                          if (this.generalBooking.CivilIdFront != null && this.generalBooking.CivilIdBack == null) {
                              this.IsselectPatientSearch1 = true;
                              if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
                                  this.SelecterrMsg1 = "Please upload the CPR NO Back image";
                              }
                              else {
                                  this.SelecterrMsg1 = "Please upload the Civil ID Back image";
                              }
                               
                            }
                    }                   
             
                    else {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please select one patient id";
                    }

                }
                this.loading = false;
            }
        }

    }
    SaveAppointmentPatientLater(radiotextvalue) {
        this.generalBooking.IsDocumentAttached = this.IsDocumentAttached;
       // this.generalBooking.PrivatePaymentType = "Private";
        if (radiotextvalue != undefined) {
            if (radiotextvalue == "selfPay") {
                this.generalBooking.PrivatePaymentType = "Private";
				this.IsValidInsuredDoc=true;
            }
            else {
                this.generalBooking.PrivatePaymentType = "Insured";
				if(this.IsPatientReqInsurance==false && this.IsPatientCivilRed==false)
				{
					this.IsValidInsuredDoc=true;
				}
				else{
					this.IsValidInsuredDoc=false;
				}
            }
        }
        if (this.generalBooking.Email != null && this.generalBooking.Email != "" && this.generalBooking.Email != undefined) {
            if (this.generalBooking.Email.indexOf("@") <= 0 || (this.generalBooking.Email.indexOf(".") <= 0)) {
                this.IsSelectEmailValidation = true;
            }
            else {
                this.IsSelectEmailValidation = false;
            }
        }
        else {
            this.IsSelectEmailValidation = false;
        }
        if (this.IsGuestEmailReq == true) {
            if (this.generalBooking.Email == null || this.generalBooking.Email == "" || this.generalBooking.Email == undefined) {
                this.IsSelectEmailRed = true;
            }
            else {
                this.IsSelectEmailValidation = false;
            }
        }
        if (this.IsPatientOBGYN == true || this.IsPatientPediatric == true) {
            this.IsPatientValidFailed = true;
            this.IsPatientValid.open();
            if (this.IsPatientOBGYN == true) {
                this.message = "Visit is Not Allowed For Male Patients in this Department.";
            }
            if (this.IsPatientPediatric == true) {
                this.message = "Patient age should be less than '15' to schedule in pediatrics costcenter.";
            }

        }
        else {
            this.IsPatientValidFailed = false;
            if (this.generalBooking.PrivatePaymentType != null && this.generalBooking.PrivatePaymentType != undefined && this.generalBooking.PrivatePaymentType != ""
                && this.generalBooking.patientId != null && this.generalBooking.patientId != "" && this.generalBooking.patientId != undefined && this.SearchMobileNumber != null
                && this.SearchMobileNumber != "" && this.SearchMobileNumber != undefined && this.CvilIdNoRed == false && this.TermsChecked == true
                && this.IsSelectEmailValidation == false && this.IsSelectEmailRed == false && this.SearchMobileNumber.length >= 8 && this.IsValidInsuredDoc==true
                && (this.IsUploadDocVisble == false || (this.IsUploadDocVisble == true && this.generalBooking.IsDocumentAttached == true)) && this.IsuploadValidationErrorMsg == false &&
                (this.IsUploadDocVisble == false || (this.IsUploadDocVisble == true && (this.generalBooking.CivilIdFront != null && this.generalBooking.CivilIdBack != null) || (this.generalBooking.PassportFront != null || this.generalBooking.PassportBack != null)))) {
                this.generalBooking.buttonActivity = "PaymentLater";
                this.generalBooking.MobileNo = this.SearchMobileNumber;
                this.SelecterrMsg1 = "";
                this.SubmitForm();
                this.clearPatientValues();
                this.clearValues();
                this.viewModelPopup.close();
                this.appointmentBooking = false;
            }
            else {
               
                if ((this.generalBooking.PrivatePaymentType == null || this.generalBooking.PrivatePaymentType == "" || this.generalBooking.PrivatePaymentType == undefined)
                    && (this.generalBooking.patientId == null || this.generalBooking.patientId == "" || this.generalBooking.patientId == undefined) &&
                    (this.SearchMobileNumber == null || this.SearchMobileNumber == "" || this.SearchMobileNumber == undefined)) {
                    this.IsselectPatientSearch1 = true;
                    this.SelecterrMsg1 = "Please select one patient id and enter the phone number also";
                }
                else {
                    if (this.SearchMobileNumber == null || this.SearchMobileNumber == "" || this.SearchMobileNumber == undefined) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please enter the mobile number";
                    }
                    else if (this.SearchMobileNumber.length < 8) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Mobile number should not be less than 8 digits";
                    }
                    else if (this.IsSelectEmailRed == true) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Email is Required";
                    }
                    else if (this.IsSelectEmailValidation == true) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Email is not valid";
                    }
                    else if (this.generalBooking.PrivatePaymentType == null || this.generalBooking.PrivatePaymentType == "" || this.generalBooking.PrivatePaymentType == undefined) {
                        this.IsselectPatientSearch1 = true;
                        if (this.payLaterStatus == "TRUE")
                            this.SelecterrMsg1 = "Please select whether you are proceeding as 'Insured' or 'Non-insured'.";
                        else
                            this.SelecterrMsg1 = "Please select Self Pay option";
                    }
                    else if (this.TermsChecked == false) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please select Terms and conditions option";
                    }
                    else if (this.IsUploadDocVisble == true && this.generalBooking.IsDocumentAttached == false) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please select the Document Attached option";
                    }
                    else if (this.IsuploadValidationErrorMsg == true) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please Upload Only .jpg,.png and pdf format Files";;
                    }
                    else if (this.IsUploadDocVisble == true && this.generalBooking.CivilIdFront == null && this.generalBooking.CivilIdBack == null && this.generalBooking.PassportFront == null && this.generalBooking.PassportBack == null) {
                        this.IsselectPatientSearch1 = true;
                        if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
                            this.SelecterrMsg1 = "Please upload any one CPRNO or Passport image";
                        }
                        else {
                            this.SelecterrMsg1 = "Please upload any one Civil or Passport image";
                        }
                    }
                    else if (this.IsUploadDocVisble == true && (this.generalBooking.CivilIdFront == null && this.generalBooking.CivilIdBack != null) || (this.generalBooking.CivilIdFront != null && this.generalBooking.CivilIdBack == null)) {
                        if (this.generalBooking.CivilIdFront == null && this.generalBooking.CivilIdBack != null) {
                            this.IsselectPatientSearch1 = true;
                            if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
                                this.SelecterrMsg1 = "Please upload the CPR NO Front image";
                            }
                            else {
                                this.SelecterrMsg1 = "Please upload the Civil ID Front image";
                            }
                        }
                        if (this.generalBooking.CivilIdFront != null && this.generalBooking.CivilIdBack == null) {
                            this.IsselectPatientSearch1 = true;
                            if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
                                this.SelecterrMsg1 = "Please upload the CPR NO Back image";
                            }
                            else {
                                this.SelecterrMsg1 = "Please upload the Civil ID Back image";
                            }

                        }
                    } 
					else if(this.IsValidInsuredDoc==false && this.IsPatientReqInsurance==true && this.IsPatientCivilRed==true)
					{
						this.IsselectPatientSearch1 = true;
						this.SelecterrMsg1 = "Please upload the Insurance and Civil Document";
					}   
					else if(this.IsValidInsuredDoc==false && this.IsPatientReqInsurance==true)
					{
						this.IsselectPatientSearch1 = true;
						this.SelecterrMsg1 = "Please upload the Insurance Document";
					}
					else if(this.IsValidInsuredDoc==false &&  this.IsPatientCivilRed==true){
						this.IsselectPatientSearch1 = true;
						this.SelecterrMsg1 = "Please upload the Civil Document";
					}      
                    else {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please select one patient id";
                    }

                }
            }
        }
    }

    SaveAppointmentSLOT() {
        this.loading = true;
        this.TermsChecked = false;
        if (this.BookingType != "SLOT") {
            this.generalBooking.scheduledStartTime = this.JnhFirstSlot;
            this.generalBooking.scheduledEndTime = "";
            this.generalBooking.BookingStatus = "B";
            this.generalBooking.ScreenName = "GA";
        }
        //if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
        //    if (this.ISDocDepartOption == this.generalBooking.departmentIdofChosenDoctor) {
        //        this.IsProceedPaybutton = true;
        //    }
        //    else {
        //        this.IsProceedPaybutton = false;
        //    }
        //}
        if ((this.isSlotValueChosen && this.BookingType == "SLOT") || (this.BookingType != "SLOT" && this.JnhFirstSlot != "" && this.JnhFirstSlot != undefined && this.JnhFirstSlot != null)) {
            this.slotErrorMessage = "NO";
            this.loading = false;
            if (this.generalBooking.IS_BOOK_ALLOW != null && this.generalBooking.IS_BOOK_ALLOW != "" && this.generalBooking.IS_BOOK_ALLOW != undefined && this.generalBooking.IS_BOOK_ALLOW == 'N') {
                this.IsBookingDoctorOnline = true;
                this.BookingDoctorOnline.open();
            }
            else {
                this.generalBooking.BookingStatus = "L";
                var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
                if ((this.checkcontrolbook == true && this.BookingType == "SLOT") || (this.BookingType != "SLOT")) {
                    this._bookingService.updateChosenSlotGuest(this.generalBooking, userData)
                        .subscribe(
                            p => {
                                this.loading = false;
                                if (p.message != 0) {
                                    this.message = p.message;
                                    this.slotBookingFailed = true;
                                    this.selectedSlotClass = "";
                                    this.slotAllotment.open();
                                    this.checkcontrolbook = false;
                                }
                                else {
                                    this.slotBookingFailed = false;
                                    this.slotAllotment.close();
                                    this.generalBooking.ScheduleAppNo = p.ScheduleAppNo;
                                    this.checkcontrolbook = false;
                                    this.IsBookingDoctorOnline = false;
                                    this.clearValues();
                                    this.viewModelPopup.close();
                                    this.appointmentBooking = true;
                                }
                            },
                            err => {
                                this.loading = false;
                                console.log("Error while getting department data...");
                            });
                    this.loading = false;
                }
                else {
                    this.checkcontrolbook = false;
                    this.loading = false;
                }

            }
            this.isSlotValueChosen = false;
            this.loading = false;
        }
        else {
            this.slotErrorMessage = "YES";
            this.isSlotValueChosen = true;
            this.loading = false;
        }
       
    }

    SaveAppointment() {
        this.generalBooking.buttonActivity = "";
        if (this.TermsChecked == false) {
            this.IsselectPatientSearch1 = true;
            this.SelecterrMsg1 = "Please select Terms and conditions option";
        }
        else {
            this.slotErrorMessage = "NO";
            this.generalBooking.patientId = "0";
            this.guestBooking = true;
            this.clearValues();
            this.LoadData();
            this.clearNewPatientValues();
            this.viewModelPopup.close();
            this.appointmentBooking = false;
        }
    }
    CancelPopup() {
        this.SlotCancel();
        this.guestBooking = false;
        this.enableProceed = false;
        this.clearValues();
        this.clearPatientValues();
    }

    ValidateGuestInfo() {
        if (this.FirstName.trim() == null || this.FirstName.trim() == "") {
            this.IsFirstNameRed = true;
        }
        else {
            this.IsFirstNameRed = false;
        }
      
       if (this.MiddleName.trim() == null || this.MiddleName.trim() == "") {
            this.IsMiddleNameRed = true;
        }
        else {
            this.IsMiddleNameRed = false;
        }

        if (this.LastName.trim() == null || this.LastName.trim() == "") {
            this.IsLastNameRed = true;
        }
        else {
            this.IsLastNameRed = false;
        }

        if (this.generalBooking.MobileNo == null || this.generalBooking.MobileNo == "") {
            this.IsMobileNoRed = true;
        }
        else {
            this.IsMobileNoRed = false;
            if (this.generalBooking.MobileNo.length < 8)
                this.MobileNoValid = true;
            else
                this.MobileNoValid = false;
        }

        if (this.IsGuestEmailReq == true) {
            if (this.generalBooking.Email == null || this.generalBooking.Email == "" || this.generalBooking.Email == undefined) {
                this.IsEmailRed = true;
            }
            else
                this.IsEmailRed = false;
        }
        if (this.generalBooking.Email != null && this.generalBooking.Email != "" && this.generalBooking.Email != "") {
            if (this.generalBooking.Email.indexOf("@") <= 0 || (this.generalBooking.Email.indexOf(".") <= 0))
            {
                this.IsEmailValidation = true;
            }
            else {
                this.IsEmailValidation = false;
            }
        }
        else {
            this.IsEmailValidation = false;
        }
        this.ValidateNationality();
        this.ValidateTitle();
        this.ValidateAlternateNo();
        this.ValidateAlternateType();
        this.ValidateDob();
        this.ValidateGender();
        this.ValidateTown();
        this.ValidateFlat();
        this.ValidateArea();
        this.ValidateBlock();
        this.ValidateCivilDoc();
        this.ValidateInsuranceDoc();

       

        if (this.IsReqInsurance === true) {
            if (this.IsFirstNameRed == false && this.IsLastNameRed == false && this.IsMiddleNameRed == false && this.IsMobileNoRed == false && this.MobileNoValid == false && this.IsEmailRed == false && this.IsEmailValidation == false
                && !this.IsNationalityRed && !this.AlternateTypeRed && !this.IsGenderRed && !this.IsDobRed && this.ValidDobValidityDate && !this.IsAreaRed
                && !this.IsFlatRed && !this.IsBlockRed && !this.IsTownRed && !this.AlternateNoRed && !this.IsTitleRed && !this.AlternateNoForthirty && !this.IsReqCivil && !this.IsReqInsurance) {
                if (this.MiddleName == null || this.MiddleName == "") {
                    this.MiddleName = "";
                }


                this.generalBooking.FirstName = this.FirstName;
                this.generalBooking.LastName = this.LastName;
                this.generalBooking.FirstMiddleName = this.MiddleName;

              
                this.SubmitForm();
            }
        } else 
        {
        if (this.IsFirstNameRed == false && this.IsLastNameRed == false && this.IsMiddleNameRed == false && this.IsMobileNoRed == false && this.MobileNoValid == false && this.IsEmailRed == false && this.IsEmailValidation == false
            && !this.IsNationalityRed && !this.AlternateTypeRed && !this.IsGenderRed && !this.IsDobRed && this.ValidDobValidityDate && !this.IsAreaRed
            && !this.IsFlatRed && !this.IsBlockRed && !this.IsTownRed && !this.AlternateNoRed && !this.IsTitleRed && !this.AlternateNoForthirty && !this.IsReqCivil) {
            if (this.MiddleName == null || this.MiddleName == "") {
                this.MiddleName = "";
            }


            this.generalBooking.FirstName = this.FirstName;
            this.generalBooking.LastName = this.LastName;
            this.generalBooking.FirstMiddleName = this.MiddleName;

            this.SubmitForm();
            }
    }
    }

    SubmitForm() {
        this.loadingProcess.open();
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this.generalBooking.patientName = this.FirstName + " " + this.MiddleName + " " + this.LastName;
        this.generalBooking.ScreenName = "GuestAppointment";
        this.generalBooking.BookingStatus = "L";
        if (this.generalBooking.patientId != null && this.generalBooking.patientId != undefined && this.generalBooking.patientId != "")
            this.generalBooking.Id = this.generalBooking.patientId;
        localStorage.setItem("KioskORPortal", this.KioskORPortal);
        if (this.generalBooking.buttonActivity == "Payment") {
            this._bookingService.SaveAppointmentGuest(this.generalBooking, userData)
                .subscribe(
                    result => {
                        if (result.AppointmentResult == "Success") {
						this.loadingProcess.close();
                            if (this.generalBooking.PaymentTypeMode == "MAXWALLET") { this.BSHMaxWalletQrCode(); }
                            else { 
                            if (this.generalBooking.PaymentTypeMode != "CREDIMAX") {
                                this.IsBookingConfirmed = true;
                                this.redirectString = result.PaymentRedirectSiteUrl;
                              
                                if (result.PaymentRedirectSiteUrl != null && result.AppointmentResult == "Success" && this.generalBooking.consultationFee.indexOf('-') <= 0) {
                                    window.location.href = this.redirectString;
                                }
                                else if (result.Amount == null) {
                                    this.SlotCancel();
                                    this.IsBookingConfirmed = true;
                                    this.IsValidConfirm = false;
                                    this.BookingConfirmed.open();
                                    this.loading = false;

                                }
                                else if (this.generalBooking.consultationFee.indexOf('-') <= 0) {
                                    this.SlotCancel();
                                    this.IsBookingConfirmed = true;
                                    this.IsValidConfirm = false;
                                    this.BookingConfirmed.open();
                                    this.loading = false;
                                }
                                else {
                                    this.SlotCancel();
                                    this.IsBookingConfirmed = false;
                                    this.IsValidConfirm = false;
                                    this.BookingConfirmed.open();

                                    this.isValid = false;
                                    this.loading = false;
                                }
                                this.clearValues();
                                this.clearPatientValues();
                                }
                            }

                        }
                        else {
						this.loadingProcess.close();
                            this.SlotCancel();
                            this.IsBookingConfirmed = false;
                            this.IsValidConfirm = false;
                            this.BookingConfirmed.open();
                            if (result.AppointmentResult != "" && result.AppointmentResult != undefined && result.AppointmentResult != null) {
                                this.IsUploadFailmsg = true;
                                this.UploadFailmsg = result.AppointmentResult;
                            }
                            this.isValid = true;
                            this.clearPatientValues();
                        }
                    },
                    err => {
					this.loadingProcess.close();
                        console.log("Error while getting data...");
                    });
        }
        else {
           
            this.loadingindicator.open();
            this.generalBooking.AlternateType = this.AlternateType;
            this._bookingService.SaveAppointmentGuest(this.generalBooking, userData)
                .subscribe(
                    result => {
                        if (result.AppointmentResult == "Success") {
						this.loadingProcess.close();
                            this.PayedDeptName = result.DeptName;
                            this.PayedDoctorName = result.DoctorName;
                            this.PayedPayAmount = result.PayAmount;
                            this.PayedSlot = result.Slot;
                            this.AppointmentDate = result.AppointmentDate;
                            this.IsBookingConfirmed = true;
                            this.guestBooking = false;
                            this.IsValidConfirm = true;
                            this.loading = false;
                            this.BookingConfirmed.open();
                            window.document.getElementById("closeBtn").click();
                            this.clearValues();
                            this.clearPatientValues();
                        }
                        else {
						this.loadingProcess.close();
                            window.document.getElementById("closeBtn").click();
                            this.IsBookingConfirmed = true;
                            this.IsValidConfirm = false;
                            this.loading = false;
                            this.BookingConfirmed.open();
                            if (result.AppointmentResult != "" && result.AppointmentResult != undefined && result.AppointmentResult != null) {
                                this.IsUploadFailmsg = true;
                                this.UploadFailmsg = result.AppointmentResult;
                            }
                            this.isValid = true;
                            this.clearPatientValues();
                        }

                    },
                    err => {
					this.loadingProcess.close();
                        console.log("Error while getting data...");
                    });
        }
    }

  clearNewPatientValues()
  {
      this.generalBooking.InsuredOrSelf = "";
	  //this.generalBooking.PatientInsuredOrSelf = "";
      this.generalBooking.BlockNo = "";
      this.generalBooking.Town = "";
      this.generalBooking.flatno = "";
      this.generalBooking.AreaCode = "";
      this.generalBooking.EnteredDateofBirth = "";
      this.generalBooking.CivilIdDoc = null;
      this.generalBooking.InsuredIdDoc = null;
      this.generalBooking.CivilIdFront = null;
      this.generalBooking.CivilIdBack = null;
      this.generalBooking.PassportBack = null;
      this.generalBooking.PassportFront = null;
      this.generalBooking.VisaAttach = null;
      this.generalBooking.MOHAttach = null;
      this.generalBooking.AlternateNo = "";
      this.generalBooking.IsDocumentAttached = false;
      this.IsDocumentAttached = false;
      this.generalBooking.AlternateType = "";
      this.generalBooking.Nationality = "";
      this.generalBooking.TitleCode = "";
      this.generalBooking.Sex = "";
      this.EnteredDateofBirth = "";
      this.IsTitleRed = false;
      this.IsNationalityRed = false;
      this.IsTitleRed = false;
      this.AlternateTypeRed = false;
      this.AlternateNoRed = false;
      this.IsAlternateNoNumeric = true;
      this.AlternateNoForthirty = false;
      this.IsGenderRed = false;
      this.ValidDobValidityDate = true;
      this.IsDobRed = false;
      this.IsAreaRed = false;
      this.IsFlatRed = false;
      this.IsBlockRed = false;
      this.IsTownRed = false;
      this.IsCivilRed = false;
      this.IsReqInsurance = false;
}
    clearValues() {
        this.FirstName = "";
        this.MiddleName = "";
        this.LastName = "";
        this.EnteredDateofBirth= "";
        this.generalBooking.MobileNo = "";
        this.InsuredOrSelf = '';
        this.PatientInsuredOrSelf= '';
        this.generalBooking.Email = "";
        this.IsFirstNameRed = false;
        this.IsLastNameRed = false;
        this.IsMiddleNameRed = false;
        this.IsMobileNoRed = false;
        this.MobileNoValid = false;

        this.IsEmailRed = false;
        this.IsEmailValidation = false;
       
        this.IsSelectEmailRed = false;
        this.IsSelectEmailValidation = false;
        this.selectedPatientId = "";
        this.enableProceed = false;
        this.IsPatientValidFailed = false;
        this.IsPatientOBGYN = false;
        this.IsPatientPediatric = false;
        this.fileSearchRes = [];
        this.fileSearch = new FileSearch();
        this.TermsChecked = false;
        
    }

    BackToLogin() {
        localStorage.setItem("KioskORPortal", this.KioskORPortal);
        if (this.KioskORPortal == "KIOSK") {
            this.router.navigate(["/KioskLogin"]);
        }
        else {
            this.router.navigate(["/Login"]);
        }
    }

    closeSlotAllotmentpopup() {
        this.slotAllotment.close();
    }

    clearPatientValues() {
        this.appointmentPatientId = "";
        this.appointmentCivilId = "";
        this.fileSearchRes = [];
        this.enableProceed = false;
        this.SelecterrMsg = "";
        this.IsselectPatientSearch = false;
        this.IsselectPatientSearch1 = false;
        this.SelecterrMsg1 = "";
        this.selectedPatientId = "";
        this.generalBooking.patientId = "";
        this.IsPatientcountone = false;
        this.CvilIdNoRed = false;
        this.IsMobileText = false;
        this.selectedPatientId = "";
        this.enableProceed = false;
        this.IsPatientValidFailed = false;
        this.IsPatientOBGYN = false;
        this.IsPatientPediatric = false;
        this.fileSearch = new FileSearch();
        this.IsSearchMobileNumberRed = false;
        this.SearchMobileNumber = "";
        this.IsPrivateChecked = false;
      
        this.IsPopupPayment = false;
        this.generalBooking.PrivatePaymentType = "";
        this.TermsChecked = false;
        this.generalBooking.buttonActivity = "";
    }
    radioClick(patientId, PediatricDept, PediatricAge, OBGYDept, Sex, Age) {
        this.IsPatientPediatric = false;
        this.IsPatientOBGYN = false;
        this.generalBooking.patientId = patientId;
        this.selectedPatientId = patientId;
        if (this.generalBooking.departmentIdofChosenDoctor == PediatricDept) {
            if (Number(Age) > Number(PediatricAge)) {
                this.IsPatientPediatric = true;
            }
            else {
                this.IsPatientPediatric = false;
            }
        }
        if (this.generalBooking.departmentIdofChosenDoctor == OBGYDept) {
            if (Sex == "M") {
                this.IsPatientOBGYN = true;
            }
            else {
                this.IsPatientOBGYN = false;
            }
        }
        this.enableProceed = true;
    }

    Search() {
        this.TermsChecked = false;
        this.fileSearch.PatientId = "";
        this.fileSearch.CPRNO = "";
        this.SearchMobileNumber = "";
        this.generalBooking.CivilIdFront = null;
        this.generalBooking.CivilIdBack = null;
        this.generalBooking.PassportBack = null;
        this.generalBooking.PassportFront = null;
        this.generalBooking.VisaAttach = null;
        this.generalBooking.MOHAttach = null;
        this.fileSearchRes = [];
        this.fileSearch = new FileSearch();
        this.selectedPatientId = "";
        this.generalBooking.patientId = "";
        this.IsselectPatientSearch1 = false;
        this.SelecterrMsg1 = "";
        this.IsPrivateChecked = false;
		this.IsPatientInsuranceReq= false;
		this.IsPatientCivilRed= false;
		
        if (this.ISDocDepartOption == this.generalBooking.departmentIdofChosenDoctor && this.ISReqDocOption == true)
            this.IsUploadDocVisble = true;
        else
            this.IsUploadDocVisble = false;

        this.generalBooking.PrivatePaymentType = "";
        if ((this.appointmentPatientId == "" || this.appointmentPatientId == undefined || this.appointmentPatientId == null)
            && (this.appointmentCivilId == "" || this.appointmentCivilId == undefined || this.appointmentCivilId == null)) {
            this.SelecterrMsg = "Please enter the required mandatory(*) filed.";
            this.IsselectPatientSearch = true;
            this.CvilIdNoRed = false;
            this.IsMobileText = false;
            this.enableProceed = false;
        }
        else if ((this.appointmentPatientId == "" || this.appointmentPatientId == undefined || this.appointmentPatientId == null)
            && (this.appointmentCivilId != "" || this.appointmentCivilId != undefined || this.appointmentCivilId != null) && this.appointmentCivilId.length < Number(this.CPRNOlength)) {
            this.SelecterrMsg = "";
            this.IsselectPatientSearch = false;
            if (this.appointmentCivilId.length == Number(this.CPRNOlength))
                this.CvilIdNoRed = false;
            else
                this.CvilIdNoRed = true;

            this.IsMobileText = false;
            this.enableProceed = false;
        }
        else {
            this.CvilIdNoRed = false;
            this.SelecterrMsg1 = "";
            this.SelecterrMsg = "";
            this.fileSearch.PatientId = this.appointmentPatientId;

            this.fileSearch.CPRNO = this.appointmentCivilId;

            this._LoginService.getAppointmentPatientSearch(this.fileSearch)
                .subscribe(
                    p => {
                        if (p != null) {
                            if (!p.IsValidPatient) {
                                if (localStorage.getItem("HospitalName").toUpperCase() == "HADI") {
                                    this.SelecterrMsg = "Search Patient file not exist, please contact 1828282 for more info. ";
                                }
                                else {
                                    if (this.GuestNewPatientReq == "TRUE") {
                                        this.SelecterrMsg = "Search Patient is not valid, please proceed as guest ";
                                    }
                                    else {
                                        this.SelecterrMsg = "Search Patient is not valid. ";
                                    }
                                }
                                this.IsselectPatientSearch = true;
                                this.IsMobileText = false;
                                this.enableProceed = false;
                            }
                            else {


                                if (p.fileSearch.length > 0) {
                                    this.fileSearchRes = p.fileSearch;
                                   this.InsuredOrSelf = 'selfPay';
								    this.PatientInsuredOrSelf = 'selfPay';
									this.IsPatientInsuredOrSelf=false;
                                    this.selectedPatientId = p.fileSearch[0].PatientId;
                                    this.generalBooking.patientId = p.fileSearch[0].PatientId;
                                    if (this.generalBooking.departmentIdofChosenDoctor == p.fileSearch[0].PediatricDept) {
                                        if (Number(p.fileSearch[0].Age) > Number(p.fileSearch[0].PediatricAge)) {
                                            this.IsPatientPediatric = true;
                                        }
                                        else {
                                            this.IsPatientPediatric = false;
                                        }
                                    }
                                    if (this.generalBooking.departmentIdofChosenDoctor == p.fileSearch[0].OBGYDept) {
                                        if (p.fileSearch[0].Sex == "M") {
                                            this.IsPatientOBGYN = true;
                                        }
                                        else {
                                            this.IsPatientOBGYN = false;
                                        }
                                    }
                                    if (p.fileSearch.length == 1) {
                                        this.IsPatientcountone = true;
                                        this.IsMobileText = true;
                                        this.enableProceed = true;
                                    }
                                    else {
                                        this.IsPatientcountone = false;
                                        this.IsMobileText = true;
                                        if (this.generalBooking.patientId != "" && this.generalBooking.patientId != null && this.generalBooking.patientId != undefined)
                                            this.enableProceed = true;
                                        else
                                            this.enableProceed = false;
                                    }
                                    this.SelecterrMsg = "";
                                    this.IsselectPatientSearch = false;
                                }
                            }

                        }
                    },
                    err => {
                       
                        console.log("Error while validating...");
                    }

                );
        }
    }
    AlertOK() { }
    PaymentConfirm() {
        this.router.navigate(["/GuestAppointment"]);
    }

    AppointmentPopup() {
        this.appointmentBooking = true;
        this.clearPatientValues();
        this.viewModelPopup.close();
    }



    AlternateNoChange(event) {
        this.IsselectPatientSearch = false;
        if (event.target.value.length > Number(this.CPRNOlength) || event.target.value.length != Number(this.CPRNOlength)) {
            this.CvilIdNoRed = true;
        }
        else {
            this.CvilIdNoRed = false;
        }
    }

    MobileNoChange(event) {
        this.IsselectPatientSearch = false;
        if (event.target.value.length > 8 || event.target.value.length != 8) {
            this.MobileNoValid = true;
        }
        else {
            this.MobileNoValid = false;
        }
    }
    MobileNoChange1(event) {
        this.IsselectPatientSearch = false;
        if (event.target.value.length > 8 || event.target.value.length != 8) {
            this.MobileNoValid1 = true;
        }
        else {
            this.MobileNoValid1 = false;
        }
    }

    keyPress(event: any) {
       
        const pattern = /[0-9\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    CancelPatientPopup() {
        this.SlotCancel();
        this.IsDocumentAttached = false;
        this.appointmentBooking = false;
        this.enableProceed = false;
        this.clearValues();
        this.clearPatientValues();
    }
    PaymentPopupProceed(radioPayment) {
        if (radioPayment != undefined) {
            if (radioPayment == 0) {
                this.generalBooking.PaymentTypeMode = "CREDIMAX";
                this.payCredimaxWithCreditCard();
            }
            else if (radioPayment == 1) {
                this.generalBooking.PaymentTypeMode = "BENEFIT";
            }
            else {
                this.WalletradioClick();
                this.generalBooking.PaymentTypeMode = "MAXWALLET";
               // this.BSHMaxWalletQrCode(); 
            }
        }
        this.generalBooking.buttonActivity = "Payment";
        this.SubmitForm();
        this.PopupPayment.close();
        this.IsPopupPayment = false;
        this.clearValues();
        this.clearPatientValues();

    }

    OnChangeCredit(radioPayment) {
        if (radioPayment != undefined) {
            if (radioPayment == 0) {
                this.generalBooking.PaymentTypeMode = "CREDIMAX";
                var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);

                this._bookingService.PaymentModeSelectionGuest(this.generalBooking, userData)
                    .subscribe(
                        p => {
                            this.loading = false;
                            if (p.length != 0) {
                                this.generalBooking.credimaxPaymentDetails = p.credimaxPaymentDetails;
                            }
                            else {

                            }
                        },
                        err => {
                            this.loading = false;
                            console.log("Error while getting department data...");
                        });
            }
            else {
                this.generalBooking.PaymentTypeMode = "BENEFIT";
            }
        }
    }
    payCredimaxWithCreditCard() {
        Checkout.configure({
            merchant: this.generalBooking.credimaxPaymentDetails[0].merchantId,
            order: {
                amount: this.generalBooking.credimaxPaymentDetails[0].amount,
                currency: this.generalBooking.credimaxPaymentDetails[0].currency,
                description: this.generalBooking.credimaxPaymentDetails[0].description,
                id: this.generalBooking.credimaxPaymentDetails[0].orderId
            },
            session: {
                id: this.generalBooking.credimaxPaymentDetails[0].sessionId
            },
            interaction: {
                merchant: {
                    name: this.generalBooking.credimaxPaymentDetails[0].name,
                    address: {
                        line1: 'Manama',
                        line2: 'Manama'
                    }
                }
            }
        });
        Checkout.showPaymentPage();
    }


    PrintPreview() {
        this.PrintPreviewpopup.open();
       
    }

    private handleError(error: any) {
        console.log("error : " + error);
    }

    makePdf() {
        const div = document.getElementById("Html2Pdf");
        const options = { height: div.clientHeight, width: div.clientWidth };
        html2canvas(div, options).then((canvas) => {
          
            const doc = new jspdf.jsPDF("p", "mm", "a4");
           
            const imgData = canvas.toDataURL("image/JPEG");
          
            doc.addImage(imgData, 'JPEG', 30, 30);
          
            const fileName = "Receipt.pdf";
           
            doc.save(fileName);
        });
    }

    openTermsCondition(Openval: number) {
        if (Openval == 1) {
            this.IsArabic = true;
            this.IsInstructions = false;
            this.IsEnglish = false;
        }
        if (Openval == 2) {
            this.IsInstructions = true;
            this.IsEnglish = false;
            this.IsArabic = false;
        }
        if (Openval == 0) {
            this.IsEnglish = true;
            this.IsInstructions = false;
            this.IsArabic = false;
        }
        this.openTermConditions.open();
    }

    onDobDateChanged(event: IMyDateModel) {
        if (event != undefined && event.formatted != "") {
            this.generalBooking.IsDateEnteredManually = false;
            this.IsDobRed = false;
            var dt = new Date(event.date.year, event.date.month - 1, event.date.day);
            if (dt < this.today || dt.toDateString() == this.today.toDateString()) {
                this.ValidDobValidityDate = true;
            }
            else if (dt > this.today) {
                this.ValidDobValidityDate = false;
            }
          
            this.generalBooking.EnteredDateofBirth = event.formatted;
        }
    }

    assingTabInd(event) {
        event.target.children[0].children[0].children[0].setAttribute('tabIndex', event.target.tabIndex)
        event.target.children[0].children[0].children[1].children[0].setAttribute('tabIndex', event.target.tabIndex)
    }

    isInsured(e) {
        this.IsReqOption=false;
        if (e.target.value === 'insured') {
            this.IsReqInsurance = true;
            this.IsReqCivil = true;
            this.IsCivilRed = true;
            this.generalBooking.InsuredOrSelf = 'insured';
            this.civilId.nativeElement.value = ''
            this.generalBooking.CivilIdDoc = null;
           this.insuraceId.nativeElement.value = '';
           this.civilId.nativeElement.value = '';
        }
        else {
            this.IsReqInsurance = false;
        }
    }

   isCivil(e) {
        this.IsReqOption=false;
        if (e.target.value === 'selfPay') {
            this.generalBooking.InsuredOrSelf = 'selfPay';
            //this.IsReqCivil = true;
            this.IsPatientReqSelf = true;
           this.IsPatientReqInsurance = false;
           this.insuraceId.nativeElement.value = '';
           this.generalBooking.InsuredIdDoc = null;
           this.generalBooking.CivilIdDoc = null;
           this.civilId.nativeElement.value = '';
         }
        
    }
	PatientisInsured(e) {
       // this.ISSelfPayOption="FALSE";
		this.IsPatientInsuredOrSelf = true;
        if (e.target.value === 'insured') {
           this.IsPatientReqCivil = true;
           this.IsPatientCivilRed = true;
           this.IsPatientReqInsurance = true;
		   this.IsPatientInsuranceReq = true;
		   this.IsProceedPaybutton=false;
            this.generalBooking.InsuredOrSelf = 'Patientinsured';
            this.generalBooking.CivilIdDoc = null;
           //this.insuraceId.nativeElement.value = '';
           this.PatientinsuraceId.nativeElement.value = '';  
		   this.PatientcivilId.nativeElement.value = ''

        }
        else {
            this.IsPatientReqInsurance = false;
        }
    }
	
   PatientisSelf(e) {
        //this.ISSelfPayOption="TRUE";
		this.IsPatientInsuredOrSelf = false;
        if (e.target.value === 'selfPay') {
            this.generalBooking.InsuredOrSelf = 'Patientselfpay';
           this.IsPatientReqCivil = false;
           this.IsPatientCivilRed = false;
           this.IsPatientReqInsurance = false;
		   this.IsPatientInsuranceReq = false;
		    this.IsProceedPaybutton=true;
           this.generalBooking.InsuredIdDoc = null;
           this.generalBooking.CivilIdDoc = null;   
		   this.PatientinsuraceId.nativeElement.value = '';
           this.PatientcivilId.nativeElement.value = '';
         }
        
    }

    UploadValidation() {
        this.IsuploadValidationErrorMsg = false;
        //this.UploadValidationErrorMsg = "";
        this.IsMOHImage = false;
        this.IsVisaImage = false;
        this.IsPassportFrontImage = false;
        this.IsPassportBackImage = false;
        this.IsCivilFrontImage = false;
        this.IsCivilBackImage = false;
        if (this.generalBooking.CivilIdFront != null && this.generalBooking.CivilIdFront != undefined) {
            if (this.generalBooking.CivilIdFront.fileName.match(/.(jpg|png|pdf)$/i)) {
                this.IsCivilFrontImage = false;
            }
            else {
                this.IsCivilFrontImage = true;
            }
        }
        if (this.generalBooking.CivilIdBack != null && this.generalBooking.CivilIdBack != undefined) {
            if (this.generalBooking.CivilIdBack.fileName.match(/.(jpg|png|pdf)$/i)) {
                this.IsCivilBackImage = false;
            }
            else {
                this.IsCivilBackImage = true;
            }
        }
        if (this.generalBooking.PassportBack != null && this.generalBooking.PassportBack != undefined) {
            if (this.generalBooking.PassportBack.fileName.match(/.(jpg|png|pdf)$/i)) {
                this.IsPassportBackImage = false;
            }
            else {
                this.IsPassportBackImage = true;
            }
        }
        if (this.generalBooking.PassportFront != null && this.generalBooking.PassportFront != undefined) {
            if (this.generalBooking.PassportFront.fileName.match(/.(jpg|png|pdf)$/i)) {
                this.IsPassportFrontImage = false;
            }
            else {
                this.IsPassportFrontImage = true;
            }
        }
        if (this.generalBooking.VisaAttach != null && this.generalBooking.VisaAttach != undefined) {
            if (this.generalBooking.VisaAttach.fileName.match(/.(jpg|png|pdf)$/i)) {
                this.IsVisaImage = false;
            }
            else {
                this.IsVisaImage = true;
            }
        }
        if (this.generalBooking.MOHAttach != null && this.generalBooking.MOHAttach != undefined) {
            if (this.generalBooking.MOHAttach.fileName.match(/.(jpg|png|pdf)$/i)) {
                this.IsMOHImage = false;
            }
            else {
                this.IsMOHImage = true;
            }
        }
        if (this.IsMOHImage == true || this.IsVisaImage == true || this.IsPassportFrontImage == true || this.IsPassportBackImage == true || this.IsCivilFrontImage == true || this.IsCivilBackImage == true) {
            this.IsuploadValidationErrorMsg = true;
           // this.UploadValidationErrorMsg = "Please Upload Only .jpg,.png and pdf format Files";
        }
        else {
            this.IsuploadValidationErrorMsg = false;
           // this.UploadValidationErrorMsg = "";
        }
    }

    public getFileDetails(isCivilInsurance, e) {
        this.fileList = [];
        this.theFile = null;
        this.message = "";
        this.errormessage = "";
       
        if (isCivilInsurance === 'isCivilFront') {
            this.generalBooking.CivilIdFront = null;
        }
        if (isCivilInsurance === 'isCivilBack') {
            this.generalBooking.CivilIdBack = null;
        }
        if (isCivilInsurance === 'isPassportFront') {
            this.generalBooking.PassportFront = null;
        }
        if (isCivilInsurance === 'isPassportBack') {
            this.generalBooking.PassportBack = null;
        }
        if (isCivilInsurance === 'isVisa') {
            this.generalBooking.VisaAttach = null;
        }
        if (isCivilInsurance === 'isMOH') {
            this.generalBooking.MOHAttach = null;
        }      
        if (e.target.files && e.target.files.length > 0) {
           
            if (e.target.files[0].size < this.MAX_SIZE) {
              
                this.theFile = e.target.files[0];
                this.readAndUploadFile(this.theFile, isCivilInsurance);
                this.message = "";
                this.errormessage = "";
            }
            else {
              
                this.message = "";
                this.errormessage = "File: " + e.target.files[0].name + " is too large to upload.";

            }
        }
    }

    private readAndUploadFile(theFile: any, isCivilInsurance) {
        let file = new FileToUpload();

        file.PatientId = this.generalBooking.patientId;
        file.fileName = theFile.name;
        file.fileSize = theFile.size;
        file.fileType = theFile.type;
        file.lastModifiedTime = theFile.lastModified;
        file.lastModifiedDate = theFile.lastModifiedDate;
        if (isCivilInsurance === 'isCivil') {
            file.PatientId = '0';
            if (this.BookingType == "TOKEN")
                file.FolderType = "ID";
            else
                file.FolderType = "CIVIL";
        }
        if (isCivilInsurance === 'isInsurance') {
            file.PatientId = '0';
            file.FolderType = "INSCARD";
        }
		if (isCivilInsurance === 'isPatientCivil') {
            if (this.BookingType == "TOKEN")
                file.FolderType = "ID";
            else
                file.FolderType = "CIVIL";
        }
		if (isCivilInsurance === 'isPatientInsurance') {
            file.FolderType = "INSCARD";
        }
        if (isCivilInsurance === 'isCivilFront') {
            file.FolderType = "CIVIL";
        }
        if (isCivilInsurance === 'isCivilBack') {
            file.FolderType = "CIVIL";
        }
        if (isCivilInsurance === 'isPassportFront') {
            file.FolderType = "PASSPORT";
        }
        if (isCivilInsurance === 'isPassportBack') {
            file.FolderType = "PASSPORT";
        }
        if (isCivilInsurance === 'isVisa') {
            file.FolderType = "VISA";
        }  
        if (isCivilInsurance === 'isMOH') {
            file.FolderType = "MOH";
        }      
        let reader = new FileReader();

       
        reader.onload = () => {
            
            file.fileAsBase64 = reader.result.toString().split(',')[1].toString();
            if (isCivilInsurance === 'isCivil') {
                this.readCivilFile(file);
            }
            else if (isCivilInsurance === 'isInsurance') {
                this.readInsuranceFile(file);
            }
			if (isCivilInsurance === 'isPatientCivil') {
                this.readPatientCivilFile(file);
            }
			if (isCivilInsurance === 'isPatientInsurance') {
                this.readPatientInsuranceFile(file);
            }
            if (isCivilInsurance === 'isCivilFront') {
                this.readCivilFrontFile(file);
            }
            if (isCivilInsurance === 'isCivilBack') {
                this.readCivilBackFile(file);
            }
            if (isCivilInsurance === 'isPassportFront') {
                this.readPassportFrontFile(file);
            }
            if (isCivilInsurance === 'isPassportBack') {
                this.readPassportBackFile(file);
            }
            if (isCivilInsurance === 'isVisa') {
                this.readVisaFile(file);
            } 
            if (isCivilInsurance === 'isMOH') {
                this.readMOHFile(file);
            } 
        }
   
        reader.readAsDataURL(theFile);
    }

    readCivilFile(file) {
        this.IsReqCivil = false;
        this.IsCivilRed = false;
        this.generalBooking.CivilIdDoc = file;
       
    }

    readInsuranceFile(file) {
        this.IsReqInsurance = false;
        this.generalBooking.InsuredIdDoc = file;
      
    }
	readPatientCivilFile(file) {
        this.IsPatientReqCivil = false;
        this.IsPatientCivilRed = false;
        this.generalBooking.CivilIdDoc = file;
       
    }
	readPatientInsuranceFile(file) {
        this.IsPatientReqInsurance = false;
		this.IsPatientInsuranceReq=false;
        this.generalBooking.InsuredIdDoc = file;
      
    }
	
    readMOHFile(file) {
        this.generalBooking.MOHAttach = file;
    }
    readCivilFrontFile(file) {
        this.generalBooking.CivilIdFront = file;
    }
    readCivilBackFile(file) {
        this.generalBooking.CivilIdBack = file;
    }
    readPassportFrontFile(file) {
        this.generalBooking.PassportFront = file;
    }
    readPassportBackFile(file) {
        this.generalBooking.PassportBack = file;
    }
    readVisaFile(file) {
        this.generalBooking.VisaAttach = file;
    }

    LoadLocation() {
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this.loading = true;
        this._bookingService.getLocationGuest(userData)
            .subscribe(
                p => {
                    if (p != null) {
                        this.Locs = p.Locations;
                        if (p.DefaultLocation != null)
                            this.generalBooking.LocationId = p.DefaultLocation;
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting department data...");
                });
    }
    OnLocationChange() {
        this.IsLocationChange = true;
        this.LoadDepartments();
        this.LoadFilterReports();
        this.IsLocationChange = false;
    }

    successCallBack = (result: responseParam): void => {
        console.log(result);
        alert(result);
        //this.generalBooking.AppointmentRquestNo = this.generalBooking.ScheduleAppNo;
        
        if (result.errorCode == "200") { this.generalBooking.CaptureData = "CAPTURED"; }
        this.LoadingAfterPayment("");

    }
    errorCallBack = (result: responseParam): void => {
        console.log(result);
        alert(result);
        if (result.errorCode == "400") { this.generalBooking.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "401") { this.generalBooking.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "403") { this.generalBooking.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "404") { this.generalBooking.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "412") { this.generalBooking.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "500") { this.generalBooking.CaptureData = ""; }
        if (result.errorCode == "503") { this.generalBooking.CaptureData = ""; }
        this.LoadingAfterPayment("");
        
    }
    closeCallBack = (result: responseParam): void => {
        console.log(this.requestparamater);
        alert(result);
        this.router.navigate(["/GuestAppointment"]);
    }
    WalletradioClick() {
        //var rere = this.generalBooking.requestParam;
        var secure_hash = this.generalBooking.requestParam[0].hashedString;
        var secretKey = this.generalBooking.requestParam[0].secretKey;

        this.requestparamater.merchantId = this.generalBooking.requestParam[0].merchantId;//"03477850"; 
        this.requestparamater.transactionAmount = this.generalBooking.requestParam[0].transactionAmount;
        this.requestparamater.transactionCurrency = this.generalBooking.requestParam[0].transactionCurrency;//"BHD";
        this.requestparamater.hashedString = secure_hash;
        this.requestparamater.appId = this.generalBooking.requestParam[0].appId;//"3776553556"; 
        this.requestparamater.referenceNumber = this.generalBooking.requestParam[0].referenceNumber;
        this.requestparamater.secure_hash = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(secure_hash, secretKey));
        this.requestparamater.paymentType = this.generalBooking.requestParam[0].paymentType;
        this.requestparamater.showResult = this.generalBooking.requestParam[0].showResult;
        this.requestparamater.lang = this.generalBooking.requestParam[0].lang;
    }
    //WalletradioClick1() {
    //    var rere = this.generalBooking.requestParam;
    //    var secure_hash = 'appId="3776553556",merchantId="03477850",referenceNumber="123456-123-123456",transactionAmount="0.010",transactionCurrency="BHD"';
    //    var secretKey = "mkn3ikqkj5maer1ie89y51eo2gwz3s4d6qtk2dsh6ym4n"; //secretKey will be fixed value which can be store in DB and get

    //    this.requestparamater.merchantId = "03477850"; //MerchantId will be fixed value which can be store in DB and get
    //    this.requestparamater.transactionAmount = "0.010";//transactionAmount will be actual amount 
    //    this.requestparamater.transactionCurrency = "BHD";//transactionCurrency will be fixed value which can be store in DB and get
    //    this.requestparamater.hashedString = secure_hash;
    //    this.requestparamater.appId = "3776553556"; //appId will be fixed value which can be store in DB and get
    //    this.requestparamater.referenceNumber = "123456-123-123456";//referenceNumber is userdefine , you can combine PatientId-AppointmentNo-OtherIds
    //    this.requestparamater.secure_hash = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(secure_hash, secretKey));
    //    this.requestparamater.paymentType = "qr";//paymentType will be fixed value which can be store in DB and get
    //    this.requestparamater.showResult = "1";//showResult will be fixed value which can be store in DB and get
    //    this.requestparamater.lang = "en";//lang will be fixed value which can be store in DB and get
    //}
    BSHMaxWalletQrCode() {
        console.log(this.requestparamater);
        MaxWallet.open(this.requestparamater, this.successCallBack, this.errorCallBack, this.closeCallBack);
    }
}





// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/GuestAppointment/Component/GuestAppointment.Component.ts